import React, { createRef, lazy } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  Col,
  Container,
  Form,
  Tooltip,
  OverlayTrigger,
  Row,
  Form as Bform,
} from "react-bootstrap";
import Header from "../../Header";
import {
  Back,
  Search,
  FormCanvas,
  Message,
  RenameAttrModal,
  HideDropDown,
  AttributeModal,
  Button,
  Loader,
  Loading,
} from "../UI";
import { Formik, Form as NewForm, Field } from "formik";
import { string, object, number, array } from "yup";
import Common, * as commonData from "../../Common";
import { connect } from "react-redux";
import action from "../../Actions";
import ReactSelect, { components } from "react-select";
import StatusBar from "../UI/StatusBar";
import TimeSvg from "../UI/svg/TimeSvg";
import PlusSvg from "../UI/svg/PlusSvg";
import AddAttrSvg from "../UI/svg/AddAttrSvg";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui-dist/jquery-ui.css";
import "ag-grid-enterprise";
import { MainCellRenderer } from "./cellrenderer";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import AgGridComponent from "../AgGridComponent";
import Error from "../Error";
import "../../assets/agthemeparent.css";
import CustomFilter from "../UI/CustomFilter";
import AdvancedFilter from "../UI/AdvancedFilter";
import Modal from "../UI/modal/Modal";
import { bulkupdateData } from "../../helpers/bulkupdate";
import NewCustomFilter from "../CustomFilter/CustomFilter";
import MainCanvas from "../UI/TodoCanvas";
import ReactCustomSelect from "./customSelect/ReactCustomSelect";
import moment from "moment";
import Note from "../note_details/Note";
import DraftjsInline from "../../components/er/DraftjsInline";
import CustomOption from "../CustomOption";
import AsyncSelect from "react-select/async";
import ReactDatePicker from "react-datepicker";
import KainbanIcon from "../kanban/KainbanIcon";
import SquareIcon from "../kanban/SquareIcon";
import apiHandler from "../../utils/apiHandler";
import ReasonModal from "../ReasonModal";
import ReasonNote from "../note_details/ReasonNote";
import AttributeReturnObj from "../../utils/AttributeReturnObj";
import { deepCleanObject } from "../../utils/utility";
import { Popover, Whisper } from "rsuite";
import "rsuite/dist/rsuite.min.css";

class Details extends Common {
  constructor(props) {
    super(props);
    this.menuButton = React.createRef([]);
    this.nameclick = React.createRef(null);
    this.getgridapi = React.createRef(null);
    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      rowSelection: "multiple",
      rowData: [],
      boarddata: {},
      perPageSizeChange: 20,
      isFilterCreate: false,
      todoAttr: [],
      isShowGroup: false,
      groupColumns: [],
      getPeopleApiCall: false,
      users: {},
      activeUsers: [],
      isActiveTodoFilter: true,
      statusConditions: {},
      notes: [],
      showReason: false,
      inlineEditData: [],
      linkCopied: false,
      singleTodoParams: {},
      columnChangeFlag: false,
      showTodoNote: false,
      customSearch: false,
      todoCustomerTattleId: "",
      globalSearch: "",
      todoBoardData: {},
      defaultAsyncValue: "",
      isShowKanban: false,
      formdata: {},
      agGridStateUpdate: false,
      numRecordTodo: null,
      gridapi: "",
      showReviewCanvas: false,
      loadBoardData: false,
      isSubmitting: false,
      showtodocanvas: false,
      isLoading: false,
      bulkUpdateDone: false,
      filterMod: {},
      allCheckData: [],
      isReset: false,
      isBulkUpload: false,
      bulkProgressActive: false,
      bulkProgressPercent: 0,
      removeFilterId: "",
      filterpopup: false,
      isFilterRemove: false,
      isEdit: false,
      default_filter: [],
      filterText: "",
      customFilter: [],
      enebleClickFilter: false,
      enableCustomFilter: false,
      columnDefs: [],
      conditions: { sort: [], filter: [] },
      currentBoardName: "",
      selectColumnsCheck: [],
      modalFilterNameError: "",
      showAllattribute: false,
      specificColumn: {},
      editFilterValues: "",
      defaultColDef: {
        resizable: true,
        wrapText: true,
        autoHeight: true,
        suppressSizeToFit: false,
        suppressHorizontalScroll: true,
        scrollbarWidth: 0,
        menuTabs: ["filterMenuTab"],
        editable: true,
        suppressMenu: true,
        enableValue: true,
        enableRowGroup: true,
        // sidebar: true,
        width: 275,

        cellRenderer: MainCellRenderer,
        // headerComponent: this.customerHeaderCall,
        // suppressMovable: true,
      },
      selectedrowsdata: [],
      pageData: {},
      userdetails: "",
      loading: false,
      showAttrModal: false,
      showCanvas: false,
      createBoard: {
        board: false,
        title: "",
        message: "",
        position: "bottom-end",
        bg: "",
        code: "",
      },
      editiBoard: false,
      resetFilter: false,
      showHideColu: false,
      attribute_set_name: "",
      loginData: {},
      columnsHide: [],
      showAttrCheck: [],
      showHidden: false,
      formvalues: {},
      hidden_columns: [],
      boarddata: {},
      hidden_column_counts: 0,
      perPage: {
        pagination_default_value: 10,
        editpagesize: false,
        totalCount: 0,
      },

      renameAttr: {
        rename: false,
        attr_name: "",
        cancelRename: this.cancelRenamehandler,
        renameSubmit: this.renameSubmitHandler,
        hideModalRename: this.hideModalRename,
        addSelection: this.addSelection,
        removeSelection: this.removeSelection,
        attr_key: "",
      },
      showattrdrop: false,
      rowSelection: "multiple",
      selectedFilter: "",
      enebleAdvancedClickFilter: false,
      filterType: 0,
      advance_filter: [],
      advfilterToShow: [],
      filterName: "",
      second_attribute_set_key:
        this.props.match.params.second_attribute_set_key || "",
      shareUrl: null,
      generatingLink: false,
      isPopoverOpen: false,
    };
    this.hideshowdr = React.createRef(null);
    this.refRename = React.createRef();
    this.renameattr = React.createRef(null);
    this.paginationchnage = React.createRef(null);
    this.mainboardchange = React.createRef();
    this.boardeditFocus = React.createRef();
    this.customFilterName = React.createRef(null);
    this.scrollRef = React.createRef(null);
    this.defaultUserLogin = React.createRef(null);
    this.kanbanref = React.createRef(null);
    this.focusRef = React.createRef(null);
    this.searchRef = React.createRef(null);
    this.shareWhisperRef = React.createRef();
    this.filterLoadedRef = React.createRef(false);
  }

  handlePopoverClose = () => {
    this.setState({ isPopoverOpen: false });
  };

  onSortRequested = (params) => {
    if (params?.column?.sort === "none") {
      params.setSort("asc");
    } else if (params?.column?.sort === "desc") {
      params.setSort("asc");
    } else {
      params.setSort("desc");
    }
  };

  onCheckBoxChange = async (params) => {
    const field = params.column.colDef.field;
    const columnshiding = [...this.state.columnsHide];
    //check wheter the filed is alredy exist or not

    // if (findindex) {
    //   columnshiding.splice(findindex, 1);
    // } else {
    if (columnshiding.indexOf(field) < 0) {
      columnshiding.push(field);
    } else if (columnshiding.indexOf(field) > -1) {
      const findindex = columnshiding.indexOf(field);
      columnshiding.splice(findindex, 1);
    }

    this.setState({ ...this.state, columnsHide: columnshiding }, () => {
      this.hideSelectedRow();
    });
  };
  convertDateFormat = (date) => {
    let convertdate = moment(date).format("YYYY-MM-DD");
    return convertdate;
  };

  reactDatePickerHandler = (evt, formik, field) => {
    let date = this.convertDateFormat(evt);
    formik.setFieldValue(field, date);
  };

  singleRowSelect = (e, data) => {};
  getNoteLink = (item, setKey, type) => {
    if (type === 4 || type === 10) {
      return;
    }
    return (
      // <Link
      //   to={`/tattle/${setKey}/${item.customer_tattle_uuid}#note${
      //     item?.custom_note_uuid || item?._id
      //   }`}
      //   className="note-link"
      //   target="_blank"
      // >
      `Note ${item?.custom_note_uuid || item.id || item?._id} &nbsp;&nbsp; | &nbsp;&nbsp;`
      // </Link>
    );
  };

  // export to csv

  exportToCsv = () => {
    this.gridApi.exportDataAsCsv();
  };

  submitAttrForm = (data) => {
    const specificCols = { ...this.state.specificColumn, ...data };
    const datas = {
      ...this.state.formvalues,
      // details_pane: "details",
      ...data,
    };
    this.setState(
      {
        ...this.state,
        formvalues: datas,
        renameAttr: { ...this.state.renameAttr, ...data },
        specificColumn: specificCols,
      },
      () => {},
    );
  };

  selectAllRowHandler = (evt, params) => {
    const { name, checked } = evt.target;
    if (checked === true) {
      params.api.forEachNode(function (node) {
        node.setSelected(true);
      });
    } else {
      params.api.deselectAll();
    }
  };
  // remove custom filter

  deleteCustomFilter = (id) => {
    const customefilters = [...this.state.customFilter];
    const response = fetch(`${this.state.apiUrl}delete-custom-filter`, {
      method: "post",
      body: JSON.stringify({ filter_id: id }),
    });
    response
      .then((res) => res.json())
      .then((data) => {
        if (data.code === 200) {
          const transformCustomFilter = customefilters.filter(
            (item) => item.filter_id !== id,
          );
          this.setState((state) => {
            return {
              ...state,
              createBoard: {
                ...state.createBoard,
                board: true,
                message: data.message,
                title: data.status,
                bg: "primary",
              },
              customFilter: transformCustomFilter,
            };
          });
        }
      });
  };

  // custom filter handler

  customFilterHandler = () => {
    this.setState((state) => {
      return {
        ...state,
        enableCustomFilter: true,
      };
    });
  };

  closeCustomFilter = () => {
    this.setState((state) => {
      return {
        ...state,
        enebleClickFilter: false,
      };
    });
  };
  closeAdvanceFilter = () => {
    this.setState((state) => {
      return {
        ...state,
        enebleAdvancedClickFilter: false,
      };
    });
  };
  closeCustomFilterDropdown = () => {
    this.setState((state) => {
      return {
        ...state,
        enableCustomFilter: false,
      };
    });
  };
  hasActiveFilter = (filterMod) => {
    return !!filterMod && Object.keys(filterMod).length > 0;
  };

  handleOutsideClick = (event) => {
    if (
      this.state.isPopoverOpen &&
      this.shareWhisperRef.current &&
      !this.shareWhisperRef.current.contains(event.target)
    ) {
      this.handlePopoverClose();
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    const prevAttrKey = prevProps.match.params.attribute_set_key;
    const prevSecondKey = prevProps.match.params.second_attribute_set_key;

    const currAttrKey = this.props.match.params.attribute_set_key;
    const currSecondKey = this.props.match.params.second_attribute_set_key;

    let prev_filter_id = this.props.match.params.filter_id;
    let curremt_filter_id = this.props.match.params.filter_id;

    if (prevAttrKey !== currAttrKey || prevSecondKey !== currSecondKey || prev_filter_id !== curremt_filter_id) {
      // define an inner async function

      const fetchColumns = async () => {
        let columnsfetch = {
          key: currSecondKey ?? currAttrKey,
          app_token: this.getCommonData().app_token,
          user_uuid: this.getCommonData().user_uuid,
        };

        try {
          const rdata = await this.props.fetchAllColumns(columnsfetch);
        } catch (error) {
          console.error("Error fetching columns:", error);
        }
      };

      fetchColumns(); // call the async function
      this.setState({
        shareUrl: "",
      });
    }

    // Check both filterMod and advance_filter for changes
    const filterChanged =
      JSON.stringify(prevState.filterMod) !==
        JSON.stringify(this.state.filterMod) ||
      JSON.stringify(prevState.advance_filter) !==
        JSON.stringify(this.state.advance_filter);

    // Only reset shareUrl if filters changed and shareUrl wasn't just populated in this cycle
    if (
      filterChanged &&
      prevState.shareUrl === this.state.shareUrl &&
      this.state.shareUrl
    ) {
      this.setState({
        shareUrl: "",
        isPopoverOpen: false,
      });
    }

    // End of Share Filter

    if (prevState.notes !== this.state.notes) {
      this.scrollRef?.current?.scrollIntoView();
    }
    if (this.props !== prevProps) {
      this.focusRef.current?.focus();
      setTimeout(() => {
        this.state.selectColumnsCheck.forEach((item) => {
          const check = document.querySelector(`[col-id="${item}"]`);
          if (check) {
            check.querySelectorAll(".filter-svg path").forEach((ite) => {
              return {
                ...ite.setAttribute("stroke", "#18A0FB"),
                ...ite.setAttribute("fill", "#18A0FB"),
              };
            });
          }
        });
      }, 100);
      const attrnameset = this.props.allBoard.active_boards;
      const nameattr = attrnameset?.find(
        (item) =>
          item.attribute_set_key === this.props.match.params.attribute_set_key,
      );
      if (prevState.filterpopup !== this.props.filterpopup.board) {
        setTimeout(() => {
          this.setState({
            ...this.state,
            isFilterRemove: false,
            enebleClickFilter: false,
          });
        });
      }
      this.setState((state) => {
        return {
          ...state,
          rowData: this.props.attributes.rows,
          loginData: this.props.login,
          columnDefs: this.props.attributes.columns,
          attribute_set_name: nameattr?.attribute_set_name,
          columnChangeFlag: !this.state.columnChangeFlag,
          boarddata: {
            ...this.state.boarddata,
            ...this.props.boardData,
            ...this.getCommonData(),
          },
          loading: this.props.attributes.loading,
          hidden_columns: this.props.attributes.hidden_columns,
          filterpopup: this.props.filterpopup.board,
          users: this.props.users || {},
          hidden_column_counts: this.props.attributes.hidden_column_count,
          // createBoard: {
          //   ...state.createBoard,

          //   code: this.props.allBoard.code,
          //   message: this.props.allBoard.message,
          //   title: this.props.allBoard.status,
          //   board: this.props.allBoard.show_board,
          //   bg: this.props.allBoard.status === "success" ? "primary" : "danger",
          // },
        };
      });
      // setTimeout(() => {
      //   this.state.boarddata.is_admin != 1 &&
      //     this.columnApi?.setColumnVisible("checkiq", false);
      // });
    }
    // this.keepFocus()
  };

  gettingRangeData = () => {
    let newrangedata = null;
    const localdata = localStorage.getItem("filter");
    if (localdata && this.IsJsonString(localdata)) {
      const parsedata = JSON.parse(localdata);

      if (parsedata.hasOwnProperty(this.props.match.params.attribute_set_key)) {
        let newdatanew = parsedata[this.props.match.params.attribute_set_key];

        if (newdatanew && this.IsJsonString(newdatanew)) {
          let rangeparse = JSON.parse(newdatanew);

          if (rangeparse.hasOwnProperty("range")) {
            const rangedatedata = rangeparse["range"];

            newrangedata = rangedatedata;
          }
        }
      }
    }

    return newrangedata;
  }; // add more attribute options

  getFilterParams = (api, data) => {
    if (data !== undefined && Object.keys(data).length > 0) {
      const prevData = JSON.parse(JSON.stringify(this.state.filterMod));
      const filterKeys = Object.keys(data);

      filterKeys.forEach((ite) => {
        if (
          data.hasOwnProperty(ite) &&
          ((Array.isArray(data[ite]) && data[ite].length > 0) ||
            ((typeof data[ite] === "string" ||
              typeof data[ite] === "number" ||
              (typeof data[ite] === "object" &&
                (data[ite].hasOwnProperty(api?.colDef?.field)
                  ? Object.keys(data[ite]?.[api?.colDef?.field]).length > 0
                  : Object.keys(data[ite]).length > 0 ||
                    data[ite].length > 0))) &&
              data[ite] !== ""))
        ) {
          let columnsKeys = [
            ...this.state.selectColumnsCheck,
            ...Object.keys(data),
          ];

          let newkeysar = columnsKeys.flatMap((it) => {
            if (it == "created_date") {
              return "created_timestamp";
            } else if (it == "customer_product") {
              return "product";
            } else if (it == "customer_name") {
              return "name";
            } else if (it == "custom_effort") {
              // create request payload for custom effort filter

              let newfilter = { ...this.state.filterMod };
              newfilter["custom_effort"] = {
                ...newfilter?.["custom_effort"],
                ...Object.values(data)[0],
              };
              data = { ...data, ...newfilter };

              return api?.colDef?.field;
            } else if (it === "range") {
              return Object.keys(data[it]);
            } else {
              return it;
            }
          });

          const projectOriginalData = api?.colDef?.attribute_type === "project" ? { ...data } : null;

          if (
            data.hasOwnProperty("er") ||
            data.hasOwnProperty("support-ticket")
          ) {
            const keyy = Object.keys(data)[0];
            const vall = Object.values(data);
            data = {
              [keyy]: +vall[0],
            };
          }
          setTimeout(() => {
            let filtermod = { ...this.state.filterMod };
            if (
              api &&
              api.hasOwnProperty("colDef") &&
              (api.colDef.attribute_type === "timestamp" ||
                api.colDef.attribute_type === "start_date" ||
                api.colDef.attribute_type === "end_date" ||
                api.colDef.attribute_type === "date")
            ) {
              const gettingrangedta = this.gettingRangeData();
              if (gettingrangedta) {
                data = {
                  ...gettingrangedta,
                  ...data,
                };
              }
              filtermod = {
                ...filtermod,
                range: { ...data },
              };
            } else if (
              api &&
              api.hasOwnProperty("colDef") &&
              api.colDef.attribute_type === "project"
            ) {
              const fieldName = api.colDef.field;
              const useData = projectOriginalData || data;
              const fieldValue = useData[ite] !== undefined ? useData[ite] : useData[fieldName];
              let projectArr = Array.isArray(filtermod.project) ? [...filtermod.project] : [];
              const existingIndex = projectArr.findIndex(item => item.hasOwnProperty(fieldName));
              if (existingIndex > -1) {
                projectArr[existingIndex] = { [fieldName]: fieldValue };
              } else {
                projectArr.push({ [fieldName]: fieldValue });
              }
              filtermod = { ...filtermod, project: projectArr };
            } else {
              filtermod = { ...filtermod, ...data };
            }

            this.setState(
              {
                ...this.state,
                customSearch: true,
                agGridStateUpdate: false,
                filterMod: filtermod,
                selectColumnsCheck: [...new Set(newkeysar)],
                shareUrl: "",
              },
              () => {
                if (
                  JSON.stringify(this.state.filterMod) !==
                  JSON.stringify(prevData)
                ) {
                  if (api) {
                    const getselectedfilter =
                      localStorage.getItem("selected_filter");
                    if (getselectedfilter) {
                      this.storeFilterInLocal({
                        ...this.state.filterMod,
                        selected_filter: "",
                      });
                    } else {
                      this.storeFilterInLocal(this.state.filterMod);
                    }
                    this.onGridReady(api);
                  }
                }
              },
            );
          });
        } else {
          const newDataTransform = this.state.selectColumnsCheck.map((tra) => {
            if (tra === "customer_product") {
              return "product";
            } else if (tra === "customer_name") {
              return "name";
            } else if (tra == "custom_effort") {
              return "effort";
            } else {
              return tra;
            }
          });
          let selectcolumns = [...this.state.selectColumnsCheck];
          if (data.hasOwnProperty("custom_effort")) {
            const findIndex = newDataTransform.findIndex(
              (item) => item === api?.colDef.field,
            );

            selectcolumns.splice(findIndex, 1);
          } else {
            const findIndex = newDataTransform.findIndex(
              (item) => item === ite,
            );

            selectcolumns.splice(findIndex, 1);
          }
          const getfilterdata = this.getDataFromLocalStorage();
          let dataparse =
            commonData.IsJsonString(
              getfilterdata[this.props.match.params.attribute_set_key],
            ) &&
            JSON.parse(
              getfilterdata[this.props.match.params.attribute_set_key],
            );
          let newdatastore = {
            // ...delete dataparse[ite],
            ...dataparse,
          };
          if (newdatastore.hasOwnProperty("custom_effort")) {
            newdatastore = {
              ...delete newdatastore[ite][api?.colDef?.field],
              ...delete newdatastore[api?.colDef?.field],
              ...newdatastore,
            };
          } else {
            newdatastore = {
              ...delete newdatastore[ite],
              ...newdatastore,
            };
          }

          if (ite === "customer_type") {
            newdatastore = {
              ...delete newdatastore["key_account"],
              ...newdatastore,
            };
          }
          const getdatafomstorage = this.gettingRangeData();

          if (getdatafomstorage) {
            newdatastore = {
              ...newdatastore,
              range: {
                ...getdatafomstorage,
              },
            };
          }
          setTimeout(() => {
            if (
              api &&
              api.hasOwnProperty("colDef") &&
              (api.colDef.attribute_type === "timestamp" ||
                api.colDef.attribute_type === "start_date" ||
                api.colDef.attribute_type === "end_date" ||
                api.colDef.attribute_type === "date") &&
              newdatastore.hasOwnProperty("range") &&
              newdatastore.range.hasOwnProperty(ite)
            ) {
              delete newdatastore.range[ite];
            } else if (
              api &&
              api.hasOwnProperty("colDef") &&
              api.colDef.attribute_type === "project" &&
              newdatastore.hasOwnProperty("project") &&
              Array.isArray(newdatastore.project)
            ) {
              const fieldName = api.colDef.field;
              newdatastore.project = newdatastore.project.filter(
                (item) => !item.hasOwnProperty(fieldName)
              );
              if (newdatastore.project.length === 0) {
                delete newdatastore.project;
              }
            } else {
              newdatastore = { ...newdatastore };
            }

            if (
              newdatastore.hasOwnProperty("range") &&
              Object.keys(newdatastore.range).length === 0
            ) {
              delete newdatastore.range;
            }

            this.setState(
              {
                ...this.state,
                selectColumnsCheck: selectcolumns,
                agGridStateUpdate: false,
                filterMod: { ...newdatastore },
                isActiveTodoFilter: false,
              },
              () => {
                const getselectedfilter =
                  localStorage.getItem("selected_filter");

                let selectedfiltercheck = null;
                if (getselectedfilter && this.IsJsonString(getselectedfilter)) {
                  const parseselectfilter = JSON.parse(getselectedfilter);
                  if (
                    parseselectfilter.hasOwnProperty(
                      this.props.match.params.attribute_set_key,
                    )
                  ) {
                    selectedfiltercheck =
                      parseselectfilter[
                        this.props.match.params.attribute_set_key
                      ];
                  }
                }
                if (selectedfiltercheck) {
                  this.storeFilterInLocal({
                    ...this.state.filterMod,
                    selected_filter: "",
                  });
                } else {
                  this.storeFilterInLocal(this.state.filterMod);
                }
                this.onGridReady(api);
              },
            );
          }, 300);
        }
      });
    }
  };

  groupByKeyCreater = (params) => {
    if (params.colDef.attribute_type === "select") {
      const cellvalue = params.value[0] ? params.value[0] : params.value;
      const options = params.colDef.options;

      const data = options.find((item) => (item._id || item.id) === cellvalue);

      if (data) {
        return data.option_name;
      }
    } else if (params.colDef.attribute_type === "api") {
      const options = params.colDef.options;
      const data = options.find((item) => item.id == params.value);
      if (data) {
        return data.value;
      }
    } else if (
      params.colDef.attribute_type === "assign_to" ||
      params.colDef.attribute_type === "reporter"
    ) {
      const celldata = params.colDef.options;
      if (celldata.hasOwnProperty(params.value)) {
        return celldata[params.value].name;
      }
    }
  };

  onSelectAllCheckbox = (e, params) => {
    const { checked } = e.target;
    if (checked) {
      params.api.selectAll();
    } else {
      params.api.deselectAll();
    }
  };

  dateFormater = (params) => {
    if (params.value !== undefined) {
      var dateAsString = params.data.date;
      var dateParts = dateAsString.split("/");
      return `${dateParts[0]} - ${dateParts[1]} - ${dateParts[2]}`;
    }
  };

  addSelection = (data) => {};

  // renameing attribute

  renameAttribute = (data) => {
    const {
      column: { colDef },
    } = data;

    this.setState({
      ...this.state,
      formvalues: { ...colDef },
      renameAttr: {
        ...this.state.renameAttr,
        rename: true,
        attr_name: data.displayName,
        attr_key: data.column.colDef.field,
        attr_type: data.column.colDef.attribute_type,
        options: data.column.colDef?.options,
        attribute_grid: 6,
        ...colDef,
      },
    });
  };
  createNewOption = async (values) => {
    let newvaluescheck = {
      ...values,
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.attribute_set_key,
    };
    const resp = await fetch(`${this.state.apiUrl}select-option/create`, {
      method: "POST",
      body: JSON.stringify(newvaluescheck),
    });
    const rdata = await resp.json();

    if (rdata.code === 200) {
      const cols = this.state.columnDefs;
      const findattr = cols.find((item) => item.field === values.attribute_key);
      if (findattr) {
        const { options } = findattr;
        options.push(rdata.data[0]);
        findattr.options = options;
        this.setState((state) => {
          return {
            ...state,
            columnDefs: [...cols, findattr],

            createBoard: {
              ...state.createBoard,
              board: true,
              title: "success",
              message: rdata.message,
              bg: "primary",
              position: "bottom-end",
            },
          };
        });
      }
    }
  };
  isShowHandleGroup = () => {
    this.setState((state) => {
      return {
        ...state,
        isShowGroup: !state.isShowGroup,
        agGridStateUpdate: false,
      };
    });
  };
  getFilteredObj = (item) => {
    const filterConvert = JSON.parse(item.filter_value ?? "{}");
    if (this.IsJsonString(item.filter_value) && filterConvert) {
      const getKeys = Object.keys(filterConvert).flatMap((item) => {
        if (item === "range") {
          return Object.keys(filterConvert[item]);
        } else {
          return item;
        }
      });
      setTimeout(() => {
        this.setState(
          (state) => {
            return {
              ...state,
              isReset: false,
              selectColumnsCheck: getKeys,
              agGridStateUpdate: false,
              ...{
                ...(item.filter_type
                  ? { advance_filter: filterConvert }
                  : { filterMod: { ...filterConvert } }),
              },
              //              filterMod: { ...filterConvert },
              selectedFilter: item?.filter_id,
              default_filter: "",
              filterType: item.filter_type,
              filterName: item.filter_name,
            };
          },
          () => {
            let filterInLocal = {};
            let newfil = {
              ...filterConvert,
              selected_filter: item?.filter_id,
            };
            this.storeFilterInLocal(newfil);
            this.setState({ ...this.state, isReset: !this.state.isReset });
            this.onGridReady(this.getgridapi.current);
          },
        );
      }, 0);
    } else {
      setTimeout(() => {
        this.setState(
          (state) => {
            return {
              ...state,
              isReset: false,
              selectColumnsCheck: ["assign_to"],
              agGridStateUpdate: false,
              filterMod: { assign_to: item },
              selectedFilter: item,
              default_filter: "",
            };
          },
          () => {
            let newfil = {
              ...this.state.filterMod,
              selected_filter: item,
            };
            this.storeFilterInLocal(newfil);
            this.setState({ ...this.state, isReset: !this.state.isReset });
            this.onGridReady(this.getgridapi.current);
          },
        );
      });
    }
  };

  removeSelection = async (id) => {
    const removeoption = {
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.attribute_set_key,
      option_ids: [id],
    };
    try {
      const response = await fetch(`${this.state.apiUrl}select-option/update`, {
        method: "post",
        body: JSON.stringify(removeoption),
      });
    } catch (error) {}
  };

  cancelRenamehandler = (data) => {
    const cancerenam = { ...this.state.renameAttr };
    cancerenam.rename = data.rename;
    this.setState({
      ...this.state,
      renameAttr: { ...this.state.renameAttr, rename: data.rename },
    });
  };

  renameSubmitHandler = async (data) => {
    let newoptions = [];
    if (data.newoptionsextra) {
      data.newoptionsextra.forEach((item) => {
        newoptions.push(item.option_name);
      });
    }

    const {
      filterParams,
      filter,
      headerComponent,
      menuTabs,
      cellRenderer,
      cellEditorParams,
      cellEditor,
      detail_pane,
      enableRowGroup,
      options,
      app_token,
      user_uuid,
      ...rest
    } = { ...this.state.formvalues };
    const renamedetails = {
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.attribute_set_key,
      attribute_key: data.attr_key,
      attribute_type: data.attr_type,
      ...(newoptions.length > 0 && { options: newoptions || "" }),
      attribute_properties: {
        ...this.state.specificColumn,
        attribute_label: data.headerName,
      },
    };

    const resp = await this.props.renamingAttr(renamedetails);
    if (resp.code == 200) {
      setTimeout(() => {
        this.setState((state) => {
          return {
            ...state,
            specificColumn: {},
            // createBoard: {
            //   ...state.createBoard,
            //   board: true,
            //   message: resp.message,
            //   bg: "primary",
            //   position: "bottom-end",
            //   title: "success",
            // },
          };
        });
      });
    } else {
      setTimeout(() => {
        this.setState((state) => {
          return {
            ...state,
            specificColumn: {},
            createBoard: {
              ...state.createBoard,
              board: true,
              message: resp.message,
              bg: "danger",
              position: "bottom-end",
              title: "error",
            },
          };
        });
      });
    }
    this.setState({
      ...this.state,
      renameAttr: { ...this.state.renameAttr, rename: false },
    });
  };

  hideModalRename = (eve) => {
    this.setState({
      ...this.state,
      renameAttr: { ...this.state.renameAttr, rename: eve },
    });
  };

  enebleClickFilter = (evt, data, isEdit, id) => {
    if (data) {
      this.setState({
        ...this.state,
        editFilterValues: data,
        isEdit: isEdit,
        enebleClickFilter: true,
      });
    } else {
      this.setState((state) => {
        return {
          ...state,
          enebleClickFilter: true,
          editFilterValues: {},
          isEdit: false,
          filterMod: null,
        };
      });
    }
  };

  enebleAdvancedClickFilter = (evt, data, isEdit, id) => {
    if (data) {
      this.setState({
        editFilterValues: data,
        isEdit: isEdit,
        enebleAdvancedClickFilter: true,
        filterType: 1,
      });
    } else {
      let advfilterToShow = [];
      let checkrecentfilter = localStorage.getItem("advanced_filter");
      if (checkrecentfilter !== null) {
        let existing_filter = JSON.parse(checkrecentfilter);
        if (
          existing_filter.hasOwnProperty(
            this.props.match.params.attribute_set_key,
          )
        ) {
          let filter_to_show =
            existing_filter[this.props.match.params.attribute_set_key];
          filter_to_show = JSON.parse(filter_to_show);
          advfilterToShow = filter_to_show ? filter_to_show : []; //filter_to_show.hasOwnProperty('advance_filter') ? filter_to_show['advance_filter']:[];
        }
      }
      //         console.log(915,"here");
      this.setState((state) => {
        return {
          enebleAdvancedClickFilter: true,
          editFilterValues: {},
          isEdit: false,
          filterMod: null,
          filterType: 1,
          advfilterToShow,
        };
      });
    }
  };

  componentDidMount = async () => {
    const selectedFilterId = this.props.match.params.selectedFilterId;

    const boarddata = await this.props.getBoardDetailsActions(
      this.props.match.params.second_attribute_set_key ??
        this.props.match.params.attribute_set_key,
      this.getCommonData().user_uuid,
    );

    if (boarddata.code === 200) {
      this.setState(
        (state) => {
          return {
            boarddata: boarddata?.data[0],
            loadBoardData: true,
          };
        },
        () => {
          this.onGridReady();
        },
      );
    }
    const getId = localStorage.getItem("selected_filter");
    if (selectedFilterId || getId) {
      let newobj = {
        [this.props.match.params.attribute_set_key]: selectedFilterId,
      };
      const boarddaa = await this.boarddata;
      if (this.state.boarddata) {
        const { filter } = this.state.boarddata;
        if (getId) {
          if (
            (filter &&
              filter.hasOwnProperty("system_filter") &&
              filter.system_filter.length > 0) ||
            (filter &&
              filter.hasOwnProperty("user_filter") &&
              filter.user_filter.length > 0)
          ) {
            let merged_arr = filter.system_filter;
            if (
              filter &&
              filter.hasOwnProperty("user_filter") &&
              filter.user_filter.length > 0
            ) {
              merged_arr = filter.system_filter.concat(filter.user_filter);
            }
            const newidconvert = JSON.parse(getId);
            let filtervalue = merged_arr.find(
              (item) =>
                item.filter_id ==
                newidconvert[this.props.match.params.attribute_set_key],
            );
            if (filtervalue) {
              this.getFilteredObj(filtervalue);
              this.storeFilterInLocal({
                selected_filter:
                  newidconvert[this.props.match.params.attribute_set_key],
              });
              this.setState({
                filterName: filtervalue.filter_name,
              });
            }
          }
        }
        if (selectedFilterId) {
          if (
            filter &&
            filter.hasOwnProperty("system_filter") &&
            filter.system_filter.length > 0
          ) {
            let { system_filter } = filter;
            let filtervalue = system_filter.find(
              (item) => item.filter_id == selectedFilterId,
            );

            if (filtervalue) {
              this.getFilteredObj(filtervalue);
              this.storeFilterInLocal({
                selected_filter: selectedFilterId,
              });
            }
          }
        }

        // this.keepFocus();
      }

      // localStorage.setItem("selected_filter", JSON.stringify(newobj));
    }
    let newurl = new URLSearchParams(window.location.search).get("q");
    if (newurl) {
      const selectefilterdata = localStorage.getItem("selected_filter");

      let newconvertdata = commonData.IsJsonString(newurl)
        ? JSON.parse(newurl)
        : "";
      if ("group_by" in newconvertdata) delete newconvertdata.group_by;
      if ("columns" in newconvertdata) delete newconvertdata.columns;
      let cols = Object.keys(newconvertdata);
      setTimeout(() => {
        this.setState(
          (state) => {
            return {
              ...state,
              filterMod: {
                ...state.filterMod,
                ...newconvertdata,
              },
              filterName: "",
              selectColumnsCheck: [...state.selectColumnsCheck, ...cols],
            };
          },
          () => {
            this.storeFilterInLocal(newconvertdata);
          },
        );
      }, 0);
    }
    let { filter_id } = this.props.match.params;
    let columnsfetch = {
      key:
        this.props.match.params.second_attribute_set_key ??
        this.props.match.params.attribute_set_key,
      app_token: this.getCommonData().app_token,
      user_uuid: this.getCommonData().user_uuid,
      filter_id
    };


    const rdata = await this.props.fetchAllColumns(columnsfetch);

    if (this.props?.location?.state) {
      const {
        state: { filterdata = "", page = "", filterType = "" },
      } = this.props.location ?? {};

      if (filterdata) {
        this.getFilteredObj({
          ...filterdata,
          selected_filter: filterdata.filter_id,
        });
        window.history.replaceState(null, "");
      }

      if (page === "view") {
        //            console.log(1023, filterType);
        if (filterType) {
          this.setState(
            { ...this.state, enebleAdvancedClickFilter: true },
            () => {
              window.history.replaceState(null, "");
            },
          );
        } else {
          this.setState({ ...this.state, enebleClickFilter: true }, () => {
            window.history.replaceState(null, "");
          });
        }
      }
    }
    // if (rdata.code === 200) {
    //   this.setState((state) => {
    //     return {
    //       ...state,
    //       users: rdata.data.users || {},
    //     };
    //   });
    // }
    this.mounted = true;
    const getfilterdata = this.getDataFromLocalStorage();
    const dataparse = JSON.parse(
      getfilterdata[this.props.match.params.attribute_set_key] || "{}",
    );
    const { custom_effort, ...otherkeys } = dataparse;
    let newallkey = { ...custom_effort, ...otherkeys };
    const getkeys = Object.keys(newallkey).flatMap((item) => {
      if (item === "range") {
        return Object.keys(newallkey[item]);
      } else {
        return item;
      }
    });
    let { selected_filter, ...rest } = dataparse;
    this.setState((state) => {
      return {
        ...state,
        filterMod: rest,
        selectColumnsCheck: [...getkeys],
      };
    });
    this.props.callUserApi(this.getCommonData().app_token);
    document.addEventListener("click", this.checkTargetContainer);
    document.addEventListener("mousedown", this.handleOutsideClick);

    // Resume bulk progress polling if there is an in-progress bulk update
    const progressKey = `bulk_progress_${this.props.match.params.attribute_set_key}`;
    const savedProgress = localStorage.getItem(progressKey);
    if (savedProgress) {
      try {
        const trackingData = JSON.parse(savedProgress);
        this.setState({ bulkProgressActive: true, bulkProgressPercent: 0 }, () => {
          this.startBulkProgressPolling(trackingData, progressKey);
        });
      } catch (e) {
        localStorage.removeItem(progressKey);
      }
    }

    return () => {
      document.removeEventListener("click", this.checkTargetContainer);
      document.removeEventListener("mousedown", this.handleOutsideClick);
    };
  };
  componentWillUnmount() {
    this.mounted = false;
    document.removeEventListener("mousedown", this.handleOutsideClick);
    // Clear bulk progress polling interval on unmount
    if (this.bulkProgressInterval) {
      clearInterval(this.bulkProgressInterval);
      this.bulkProgressInterval = null;
    }
    if (this.bulkProgressTimeout) {
      clearTimeout(this.bulkProgressTimeout);
      this.bulkProgressTimeout = null;
    }
  }

  checkTargetContainer = (event) => {
    let interval_holder = setTimeout(() => {
      if (
        (this.hideshowdr.current &&
          !this.hideshowdr.current.contains(event.target)) ||
        (this.kanbanref.current &&
          !this.kanbanref.current.contains(event.target))
      ) {
        this.setState({
          ...this.state,
          showHideColu: false,
          isShowKanban: false,
        });
      }
    }, 0);

    if (
      this.refRename.current &&
      !this.refRename.current.contains(event.target)
    ) {
      this.setState({
        ...this.state,
        editiBoard: false,
      });
    }

    if (this.mainboardchange?.current) {
      if (event?.path?.indexOf(this.mainboardchange?.current) === -1) {
        this.setState({ ...this.state, editiBoard: false });
      }
    }
  };
  getKanbanViewUi = () => {
    let geturlpath =
      this.props.match.url.split("/")[
        this.props.match.url.split("/").length - 1
      ];

    if ((geturlpath && geturlpath == "list") || geturlpath === "me") {
      return (
        <div className="group_view listin">
          <OverlayTrigger
            key={"list"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-list`}>
                <strong>List View</strong>
              </Tooltip>
            }
          >
            <div className={`child_group_view_square active`}>
              <Link to={`list`}>
                {/* <SquareIcon /> */}
                <img src={`${window.location.origin}/list.png`} width={24} />
              </Link>
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            key={"kanban"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-kanban`}>
                <strong>Kanban View</strong>
              </Tooltip>
            }
          >
            <div className={`child_group_view_kanban`}>
              <Link
                to={`/tattle/${this.props.match.params.attribute_set_key}/kanban`}
              >
                {/* <KainbanIcon /> */}
                <img src={`${window.location.origin}/grid.png`} width={24} />
              </Link>
            </div>
          </OverlayTrigger>
        </div>
      );
    } else {
      return !this.state.second_attribute_set_key ? (
        <div className="group_view">
          <OverlayTrigger
            key="kanban"
            placement="top"
            overlay={
              <Tooltip id="tooltip-kanban">
                <strong>Kanban View</strong>
              </Tooltip>
            }
          >
            <div className="child_group_view_kanban active">
              <Link to="kanban">
                <img src={`${window.location.origin}/grid.png`} width={24} />
              </Link>
            </div>
          </OverlayTrigger>

          <OverlayTrigger
            key="list"
            placement="top"
            overlay={
              <Tooltip id="tooltip-list">
                <strong>List View</strong>
              </Tooltip>
            }
          >
            <div className="child_group_view_square">
              <Link to="list">
                <SquareIcon />
              </Link>
            </div>
          </OverlayTrigger>
        </div>
      ) : (
        <></>
      );
    }
  };

  getKanbanLi = () => {
    let geturlpath =
      this.props.match.url.split("/")[
        this.props.match.url.split("/").length - 1
      ];
    return (
      <>
        {" "}
        <li className="dropdown-item">
          <Link
            to={`list`}
            className={`${geturlpath == "list" ? "active" : ""}`}
          >
            {" "}
            <span>
              <i class="fa fa-list"></i> List
            </span>
          </Link>
        </li>
        <li className="dropdown-item">
          <Link
            to={`kanban`}
            className={`${geturlpath == "kanban" ? "active" : ""}`}
          >
            <span>
              <i class="fa fa-bars"></i>
              Kanban
            </span>
          </Link>
        </li>
      </>
    );
  };

  hideSelectedRow = () => {
    const hideDetails = {
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.attribute_set_key,
      attributes: this.state.columnsHide,
      status_type: "hide",
    };

    this.props.hideColumn(hideDetails);
    this.setState({ ...this.state, columnsHide: [] });
  };

  // dynamic field created
  onSubmitAttrCreate = async (adata) => {
    let apival;
    let checkvalue;
    let dates = {};
    if (adata.attr_type === "api") {
      apival = adata.attr_api;
    }
    if (adata.attr_type === "checkbox") {
      checkvalue = adata.attr_check;
    }
    if (adata.attr_type === "date") {
      dates = { ...dates, set_current_date: adata.set_current_date };
    }
    const allcolumns = [...this.state.columnDefs];
    const {
      attr_api,
      attr_check,
      attr_date,
      attr_name,
      detail_pane,
      attr_type,
      set_current_date,
      ...resting
    } = this.state.formvalues;
    const attrData = {
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.attribute_set_key,
      attributes: [
        {
          attribute_label: adata.attr_name,
          ...{
            ...(apival && { api_url: apival }),
          },
          attribute_default_value: checkvalue || "",
          attribute_type: adata.attr_type,
          ...resting,
          ...dates,
          details_pane: "details",
          ...{
            ...(adata?.options.length > 0 && { options: adata.options }),
          },
          attribute_grid: 6,
        },
      ],
    };
    this.props.createAttribute(attrData);
  };

  //inline row editing

  checkIsCompleteHandler = async (evt, params) => {
    const { customer_tattle_uuid } = params.data;

    const form = new FormData();
    form.append("app_token", this.state.boarddata.app_token);
    form.append("attribute_set_key", this.props.match.params.attribute_set_key);
    form.append("product_key", process.env.REACT_APP_PRODUCT_KEY);
    form.append("customer_tattle_uuid", customer_tattle_uuid);
    form.append([evt.target.name], evt.target.checked);
    form.append("user_uuid", this.state.boarddata.user_uuid);

    const respo = await fetch(`${this.state.apiUrl}tattle/update`, {
      method: "post",
      body: form,
    });

    const rdata = await respo.json();
    if (rdata.code === 200) {
      this.setState((state) => {
        return {
          ...state,
          // createBoard: {
          //   ...state.createBoard,
          //   board: true,
          //   message: rdata.message,
          //   title: rdata.status,
          //   bg: "primary",
          // },
        };
      });
    } else {
      this.setState((state) => {
        return {
          ...state,
          createBoard: {
            ...state.createBoard,
            board: true,
            message: rdata.message,
            title: rdata.status,
            bg: "danger",
          },
        };
      });
    }
  };

  onRowValueChanged = async (data) => {
    const gridApi = this.gridApi;
    const { colDef } = data.column;
    const userDetails = this.getCommonData();
    const { data: indata } = data;
    // Prevent repeated updates when modal is already in progress

    if (colDef.show_reason && data.oldValue) {
      if (this.state.modalInProgress || !data.oldValue) return;
      // Stop editing in the grid
      gridApi.stopEditing();

      // Save the previous value to revert temporarily
      const previousValue = data.oldValue;

      gridApi
        .getRowNode(data.node.id)
        .setDataValue(data.column.colId, previousValue);

      // Revert the cell value temporarily to prevent unintended updates
      // gridApi
      //   .getRowNode(data.node.id)
      //   .setDataValue(data.column.colId, previousValue);

      // Open the modal and block further edits

      this.setState({
        showReason: true,
        modalData: [colDef],
        editData: data,
        modalInProgress: true, // Indicate that modal processing is ongoing
        modalCallback: async (response) => {
          if (
            typeof response.val === "object" &&
            response?.val?.hasOwnProperty("newValue") &&
            !response?.val?.newValue &&
            data?.colDef?.is_required
          ) {
            let error = {
              [data.column.colId]: `${data.colDef.headerName} can not be blank`,
            };
            this.setState((state) => {
              return {
                ...state,
                reasonError: { ...error },
              };
            });
            return;
          } else if (
            typeof response.val === "object" &&
            !response?.val &&
            data?.colDef?.is_required
          ) {
            let error = {
              [data.column.colId]: `${data.colDef.headerName} can not be blank`,
            };
            this.setState((state) => {
              return {
                ...state,
                reasonError: { ...error },
              };
            });
            return;
          } else if (!response.val && data?.colDef?.is_required) {
            let error = {
              [data.column.colId]: `${data.colDef.headerName} can not be blank`,
            };
            this.setState((state) => {
              return {
                ...state,
                reasonError: { ...error },
              };
            });
            return;
          } else {
            this.setState((state) => {
              return {
                ...state,
                reasonError: {},
              };
            });
          }

          let newvalue;

          if (
            typeof response.val === "object" &&
            (colDef.attribute_type === "date" ||
              colDef.attribute_type === "start_date" ||
              colDef.attribute_type === "end_date" ||
              colDef.attribute_type === "go_live_date")
          ) {
            newvalue = new Date(response.val);
          } else if (typeof response.val === "object") {
            newvalue = response.val[data.column.colId]?.value;
          } else {
            newvalue = response.val;
          }
          let formdata = {
            app_token: this.state.boarddata.app_token,
            attribute_set_key: this.props.match.params.attribute_set_key,
            customer_tattle_uuid: indata.customer_tattle_uuid,
            attributes: { [data.column.colId]: newvalue },
            note_content: response.data,
            user_uuid: this.state.boarddata.user_uuid,
          };

          if (
            data?.colDef?.details_pane === "planning_date" ||
            data?.colDef?.details_pane === "qa_project_plan" ||
            data?.colDef?.details_pane === "scrum_project_plan"
          ) {
            formdata = {
              ...formdata,
              event_id: 42,
            };
          }
          const resp = await fetch(`${this.state.apiUrl}add-reason`, {
            method: "POST",
            body: JSON.stringify(formdata),
          });

          // Only update the value if the modal action is successful
          // if (response?.val) {
          //   gridApi
          //     .getRowNode(data.node.id)
          //     .setDataValue(data.column.colId, new Date(response.val));
          // }

          // Reset modal-related states to allow further updates
          this.setState(
            {
              modalInProgress: false,
              showReason: false,
            },
            () => {
              let columnsfetch = {
                key:
                  this.props.match.params.second_attribute_set_key ??
                  this.props.match.params.attribute_set_key,
                app_token: this.state.boarddata.app_token,
                user_uuid: this.state.boarddata.user_uuid,
              };

              this.props.fetchAllColumns(columnsfetch);
              this.getgridapi.current?.api?.setServerSideDatasource(
                this.datasource,
              );
            },
          );
        },
      });

      return; // Exit early to prevent other actions
    } else {
      let value = "";
      if (colDef.attribute_type === "assign_to") {
        const formdata = {
          app_token: this.state.boarddata.app_token,
          attribute_set_key: this.props.match.params.attribute_set_key,
          attribute_key: colDef.field,
          customer_tattle_uuid: indata.customer_tattle_uuid,
          attribute_type: colDef.attribute_type,
          attribute_value: data?.value,
          user_uuid: this.state.boarddata.user_uuid,
        };
        const resp = await apiHandler(colDef.attribute_type, formdata);
      } else if (colDef.attribute_type === "effort") {
        value = { effort_data: { [data.column.colId]: { ...data.value } } };

        let formdata = {
          app_token: this.state.boarddata.app_token,
          attribute_set_key: this.props.match.params.attribute_set_key,
          customer_tattle_uuid: indata.customer_tattle_uuid,
          ...value,
          user_uuid: this.state.boarddata.user_uuid,
        };
        const resp = await apiHandler(colDef.attribute_type, formdata);
      } else if (colDef.attribute_type === "category") {
        const formdata = {
          app_token: this.state.boarddata.app_token,
          attribute_set_key: this.props.match.params.attribute_set_key,
          attribute_key: colDef.attribute_type,
          customer_tattle_uuid: indata.customer_tattle_uuid,
          category_id: data?.value,
          user_uuid: this.state.boarddata.user_uuid,
        };
        const resp = await apiHandler(colDef.attribute_type, formdata);
      } else if (colDef.attribute_type === "status") {
        const formdata = {
          app_token: this.state.boarddata.app_token,
          attribute_set_key: this.props.match.params.attribute_set_key,
          attribute_key: colDef.attribute_type,
          customer_tattle_uuid: indata.customer_tattle_uuid,
          status_id: data?.value,
          user_uuid: this.state.boarddata.user_uuid,
        };
        const resp = await apiHandler(colDef.attribute_type, formdata);
      } else {
        value = { [data.column.colId]: data.value };
        let formdata = {
          app_token: this.state.boarddata.app_token,
          attribute_set_key: this.props.match.params.attribute_set_key,
          product_key: process.env.REACT_APP_PRODUCT_KEY,
          customer_tattle_uuid: indata.customer_tattle_uuid,
          ...value,
          user_uuid: this.state.boarddata.user_uuid,
        };

        const resp = await apiHandler(null, formdata);
      }
    }
  };

  //modal cancel
  canceModal = () => {
    this.setState((state) => {
      return { ...state, showAttrModal: !this.state.showAttrModal };
    });
  };

  //show canvas fomr for attribute

  showCanvasForm = () => {
    this.setState({ ...this.state, showCanvas: !this.state.showCanvas });
  };

  // draging column move
  onrowdragmove = (ev) => {
    if (ev.source === "uiColumnDragged") {
      const {
        columnApi: {
          columnModel: { displayedTreeCentre },
        },
      } = ev;

      const newrr = [];
      const orderinsequence = {
        app_token: this.state.boarddata.app_token,
        user_uuid: this.state.boarddata.user_uuid,
        attribute_set_key: this.props.match.params.attribute_set_key,
        attributes: newrr,
      };

      displayedTreeCentre.forEach((item, i) => {
        if (item.colDef.field !== undefined) {
          newrr.push(item.colDef.field);
        }
      });

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.props.orderingColumns(orderinsequence);
      }, 200);
    } else {
      return;
    }
  };

  //inline board name chnage

  inlineBoardNameChange = (event) => {
    event.preventDefault();
    const boardDetails = {
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_name: this.state.attribute_set_name,
      attribute_set_key: this.props.match.params.attribute_set_key,
    };
    if (this.state.currentBoardName !== this.state.attribute_set_name) {
      this.props.renameSingleBoard(boardDetails);
    } else {
      setTimeout(() => {
        this.setState({ ...this.state, editiBoard: false });
      });
    }
  };
  clearBulkAction = () => {
    this.gridApi?.deselectAll?.();
    this.getgridapi.current?.api?.deselectAll?.();
    this.setState((state) => {
      return {
        selectedrowsdata: [],
      };
    });
  };
  getPeoplesCall = async (evt, apiUrl) => {
    if (evt && this.state.activeUsers.length > 0) {
      return this.state.activeUsers.filter((item) =>
        item.label.toLowerCase().includes(evt.toLowerCase()),
      );
    }

    try {
      if (!this.state.activeUsers.length > 0) {
        if (!this.state.getPeopleApiCall) {
          const resp = await fetch(apiUrl);
          const rdata = await resp.json();

          const newdata = Object.entries(rdata).map(([key, val]) => {
            return {
              label: val.name,
              value: val.user_uuid,
              profile_image: val.profile_image,
            };
          });
          this.setState(
            (state) => {
              return {
                activeUsers: newdata,
                getPeopleApiCall: true,
              };
            },
            () => {},
          );

          return newdata;
        }
      }
      return this.state.activeUsers;
    } catch (error) {
      console.log(error.message);
    }
  };

  // inline editing board
  enableinlineEditing = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        currentBoardName: this.boardeditFocus?.current?.value,
      });
    });
    this.setState({ ...this.state, editiBoard: true }, () => {
      if (this.boardeditFocus.current) {
        this.boardeditFocus.current?.focus();
      }
    });
  };

  inlineBoardNameChangeHandler = (event) => {
    const { value } = event.target;
    setTimeout(() => {
      this.setState({
        ...this.state,
        attribute_set_name: value,
      });
    });
  };

  getConstructFilterForCustomerType = (filter) => {
    let newconstructfilter = { ...filter };
    if (newconstructfilter.hasOwnProperty("customer_type")) {
      const getvalues = Object.values(filter["customer_type"]);
      newconstructfilter = {
        ...newconstructfilter,
        customer_type: getvalues,
      };
      return newconstructfilter;
    }
    return newconstructfilter;
  };

  dynamicColumnHandler = () => {
    this.setState((state) => {
      return {
        ...state,
        showAttrModal: !state.showAttrModal,
        formvalues: {
          attribute_grid: 6,
          show_on_column: true,
          filter: true,
          sortable: true,
          show_on_form: true,
          attribute_status: true,
          width: 275,
          hide: false,
          attr_type: "",
        }, 
      };
    });
  };
  
  callOnGridApiCall = (url, getRowsparamter, params) => {
    // Clean up any unwanted filter keys
    if (getRowsparamter.filter && "filter_id" in getRowsparamter.filter) {
      delete getRowsparamter.filter.filter_id;
    }
    if (getRowsparamter.filter && "search" in getRowsparamter.filter) {
      delete getRowsparamter.filter.search;
    }

    // Generate a unique request ID (timestamp based)
    const requestId = Date.now();
    this.latestRequestId = requestId;

    // Optional: Reset agGridStateUpdate before fetching
    this.setState({ agGridStateUpdate: false });

    this.setState({
      row_payload: JSON.stringify(deepCleanObject(getRowsparamter)),
    });

    fetch(url, {
      method: "post",
      body: JSON.stringify(deepCleanObject(getRowsparamter)),
    })
      .then((httpResponse) => httpResponse.json())
      .then((response) => {
        if (!response.data.length) {
          this.gridApi?.showNoRowsOverlay();
        } else {
          this.gridApi?.hideOverlay();
        }
        params.successCallback(response.data, response.total_count);
        // this.keepFocus();

        // Only update state if this is the latest response
        if (this.latestRequestId === requestId) {
          this.setState({
            numRecordTodo: response.total_count,
            agGridStateUpdate: true,
          });
        }
      })
      .catch((error) => {
        console.error("Grid data fetch error:", error);
        this.gridApi?.showNoRowsOverlay();
        params.failCallback();
      });
  };
  datasource = {
    getRows: (params) => {
      const data = this.getCommonData();
      const ordering = { sort: "", column: "" };
      const { startRow, endRow, filterModel, sortModel, rowGroupCols } =
        params.request;
      const conditions = { ...this.state.conditions };
      const { title } = filterModel;
      let getRowsparamter = {
        attribute_set_key:
          this.props.match.params.second_attribute_set_key ??
          this.props.match.params.attribute_set_key,
      };
      let url = `${this.state.apiUrl}tattle/rows`;
      //      let url = this.state.globalSearch
      //        ? `${this.state.apiUrl}tattle/fuzzyrows`
      //        : `${this.state.apiUrl}tattle/rows`;
      //Sorting
      if (sortModel.length) {
        const sortarr = [...conditions.sort];
        sortModel.forEach((item) => {
          const index = sortarr.findIndex((it) => {
            if (it) {
              return Object.keys(it)[0] === Object.values(item)[1];
            }
          });
          if (index === -1) {
            sortarr.push({ [item.colId]: item.sort });
          } else {
            sortarr.splice(index, 1, { [item.colId]: item.sort });
          }
        });
        conditions.sort = sortarr;
        const { colId, sort } = sortModel[0];
        // url += `_sort=${colId}&_order=${sort}&`;
        ordering.sort = sort;
        ordering.column = colId;
        getRowsparamter = {
          ...getRowsparamter,
          sort: colId,
          order: sort,
        };
      }
      if (rowGroupCols.length) {
        getRowsparamter = {
          ...getRowsparamter,
          groupby: rowGroupCols[0].field,
        };
      }
      //Filtering
      const filterKeys = Object.keys(filterModel);
      filterKeys.forEach((filter) => {
        getRowsparamter = {
          ...getRowsparamter,
          [filter]: filterModel[filter]?.filterModels[0].filter,
          filter: { ...this.state.filterMod },
        };
      });
      //Pagination
      const page = endRow / this.state.perPageSizeChange;
      getRowsparamter = {
        ...getRowsparamter,
        app_token: data.app_token,
        attribute_set_key:
          this.props.match.params.second_attribute_set_key ??
          this.props.match.params.attribute_set_key,
        // start: startRow,
        ...(this.state.boarddata.attribute_set_type == 4 && {
          ["sort"]: ordering.column || "created_timestamp",
          ["order"]: ordering.sort || "desc",
        }),
        per_page:
          +this.state.perPageSizeChange ||
          this.gridApi?.paginationProxy?.pageSize ||
          this.state.perPage.pagination_default_value,
        current_page:
          this.gridApi?.paginationProxy?.currentPage + 1 ||
          params.api?.paginationProxy?.currentPage + 1,
        user_uuid: data.user_uuid,
        attribute_set_type: this.state.boarddata.attribute_set_type,
        // end: endRow,
      };
      if (
        this.state.boarddata.attribute_set_type == 4 &&
        this.state.isActiveTodoFilter
      ) {
        getRowsparamter = {
          app_token: data.app_token,
          attribute_set_key:
            this.props.match.params.second_attribute_set_key ??
            this.props.match.params.attribute_set_key,
          filter: { ...this.state.filterMod },
          ...(ordering.column && {
            ["sort"]: ordering.column,
            ["order"]: ordering.sort,
          }),
          ...(this.state.globalSearch && { search: this.state.globalSearch }),
          per_page:
            +this.state.perPageSizeChange ||
            this.gridApi?.paginationProxy?.pageSize ||
            this.state.perPage.pagination_default_value,
          current_page:
            this.gridApi?.paginationProxy?.currentPage + 1 ||
            params.api?.paginationProxy?.currentPage + 1,
          user_uuid: data.user_uuid,
          attribute_set_type: this.state.boarddata.attribute_set_type,
        };
      }
      if (this.state.globalSearch) {
        getRowsparamter = {
          ...getRowsparamter,
          app_token: data.app_token,
          attribute_set_key:
            this.props.match.params.second_attribute_set_key ??
            this.props.match.params.attribute_set_key,
          // start: startRow,
          per_page:
            +this.state.perPageSizeChange ||
            this.gridApi?.paginationProxy?.pageSize ||
            this.state.perPage.pagination_default_value,
          current_page:
            this.gridApi?.paginationProxy?.currentPage + 1 ||
            params.api?.paginationProxy?.currentPage + 1,
          search: this.state.globalSearch.trim(),
          user_uuid: data.user_uuid,
          attribute_set_type: this.state.boarddata.attribute_set_type,
          // end: endRow,
        };
      }

      //     advance_filter
      if (this.state.advance_filter && this.state.advance_filter.length > 0) {
        getRowsparamter = {
          ...getRowsparamter,
          app_token: data.app_token,
          attribute_set_key:
            this.props.match.params.second_attribute_set_key ??
            this.props.match.params.attribute_set_key,
          // start: startRow,
          per_page:
            +this.state.perPageSizeChange ||
            this.gridApi?.paginationProxy?.pageSize ||
            this.state.perPage.pagination_default_value,
          current_page:
            this.gridApi?.paginationProxy?.currentPage + 1 ||
            params.api?.paginationProxy?.currentPage + 1,
          user_uuid: data.user_uuid,
          attribute_set_type: this.state.boarddata.attribute_set_type,
          advanced_filter: { ...this.state.advance_filter },
          // end: endRow,
        };
      }
      if (
        this.state.filterMod &&
        Object.keys(this.state.filterMod).length > 0 &&
        !this.state.filterType
      ) {
        //      if (Object.keys(this.state.filterMod).length > 0) {
        const datagetConstruct = this.getConstructFilterForCustomerType(
          this.state.filterMod,
        );

        const {
          created_date,
          start_date,
          qa_start_date,
          end_date,
          qa_end_date,
          go_live_date,
          last_updated,
          ...rest
        } = datagetConstruct;

        const hasDateFilters = [
          "start_date",
          "end_date",
          "qa_start_date",
          "qa_end_date",
          "go_live_date",
          "created_date",
          "last_updated",
        ].some((key) => this.state.filterMod.hasOwnProperty(key));

        let filter = { ...rest };

        if (datagetConstruct.hasOwnProperty("range")) {
          filter.range = {
            start_date,
            end_date,
            qa_start_date,
            qa_end_date,
            go_live_date,
            updated_date: last_updated,
            ...datagetConstruct.range,
          };
        } else if (rest.hasOwnProperty("range")) {
          filter.range = {
            start_date,
            end_date,
            qa_start_date,
            qa_end_date,
            go_live_date,
            updated_date: last_updated,
            ...rest.range,
          };
        } else {
          if (hasDateFilters) {
            filter.range = {
              start_date,
              end_date,
              qa_start_date,
              qa_end_date,
              go_live_date,
              updated_date: last_updated,
              ...datagetConstruct.range,
            };
          }
        }

        getRowsparamter = {
          app_token: data.app_token,
          attribute_set_key:
            this.props.match.params.second_attribute_set_key ??
            this.props.match.params.attribute_set_key,
          filter,
          ...(ordering.column && {
            ["sort"]: ordering.column,
            ["order"]: ordering.sort,
          }),
          ...(this.state.globalSearch && {
            search: this.state.globalSearch.trim(),
          }),
          per_page:
            +this.state.perPageSizeChange ||
            this.gridApi?.paginationProxy?.pageSize ||
            this.state.perPage.pagination_default_value,

          current_page:
            this.gridApi?.paginationProxy?.currentPage + 1 ||
            params.api?.paginationProxy?.currentPage + 1,
          user_uuid: data.user_uuid,
          attribute_set_type: this.state.boarddata.attribute_set_type,
        };
      }
      if (getRowsparamter.filter && "group_by" in getRowsparamter.filter)
        delete getRowsparamter.filter.group_by;
      if (getRowsparamter.filter && "columns" in getRowsparamter.filter)
        delete getRowsparamter.filter.columns;
      //url += `_start=${startRow}&per_page=${this.state.perPage.pagination_default_value}&_end=${endRow}`;
      this.gridApi?.showLoadingOverlay();
      // this.keepFocus();
      this.callOnGridApiCall(
        url,
        this.removeUndefinedKeys(getRowsparamter),
        params,
      );
    },
  };

  keepFocus = () => {
    setTimeout(() => {
      // Check if the grid API and column API are available
      if (
        !this.getgridapi.current ||
        !this.getgridapi.current.api ||
        !this.getgridapi.current.columnApi
      ) {
        console.error("Grid API or Column API is not available.");
        return;
      }
      const paginationInfo =
        this.getgridapi.current.api.paginationGetCurrentPage();
      if (paginationInfo !== 0) {
        // Do not reset focus if not on the first page
        return;
      }

      // Get the first row and all displayed columns
      const firstRowNode =
        this.getgridapi.current.api.getDisplayedRowAtIndex(0);
      const allColumns =
        this.getgridapi.current.columnApi.getAllDisplayedColumns();

      // Check if the first row and at least one column exist
      if (firstRowNode && allColumns?.length > 0) {
        const firstColumnId = allColumns[0].getColId();

        // Set focus on the first cell only if the user is on the first page
        this.getgridapi.current.api.setFocusedCell(0, firstColumnId);
        console.log("Focus set on the first cell.");
      } else {
        console.warn("First row or columns are not available.");
      }
    }, 1000); // Delay to ensure the grid is fully rendered
  };

  onGridReady = async (params) => {
    const { isFilterReset } = this.props.attributes;
    const data = this.getCommonData();
    this.gridApi = params?.api;
    this.columnApi = params?.columnApi;

    let { filter_id } = this.props.match.params;

    if (this.state.loadBoardData) {
      this.setState(
        {
          ...this.state,
          boarddata: { ...this.state.boarddata, ...data },
        },
        async () => {
          // --- Shared filter link handling ---
          if (filter_id && !this.filterLoadedRef.current) {
            this.filterLoadedRef.current = true;
            const sharedData = await this.getSharedFilter(filter_id);

            if (sharedData && Object.keys(sharedData).length > 0) {
              // response may already be an object, or a JSON string — handle both
              const parsedFilter =
                typeof sharedData === "string" && this.IsJsonString(sharedData)
                  ? JSON.parse(sharedData)
                  : sharedData;

              const filterKeys = Object.keys(parsedFilter || {});

              this.setState(
                (state) => ({
                  ...state,
                  filterMod: parsedFilter,
                  selectColumnsCheck: [...filterKeys],
                  shareUrl: `${window.location.origin}/tattle/${this.state.boarddata.attribute_set_key}/list/share/${filter_id}`,
                }),

                () => {
                  this.storeFilterInLocal({ ...this.state.filterMod });
                  if (!this.gridApi) {
                    this.getgridapi.current?.api?.setServerSideDatasource(
                      this.datasource,
                    );
                  } else {
                    this.gridApi?.setServerSideDatasource(this.datasource);
                  }
                },
              );
              return; // skip the rest of the default/local-storage filter logic
            }
          }
          // --- end shared filter handling ---

          let alredyselectfilter = localStorage.getItem("selected_filter");

          if (alredyselectfilter && this.IsJsonString(alredyselectfilter)) {
            alredyselectfilter =
              JSON.parse(alredyselectfilter)[
                this.props.match.params.attribute_set_key
              ];
          }
          if (
            this.state.boarddata.attribute_set_type == 4 &&
            !isFilterReset[this.props.match.params.attribute_set_key] &&
            !this.state.selectedFilter &&
            this.state.isActiveTodoFilter &&
            !alredyselectfilter
          ) {
            let newval;
            let columns;
            if (this.state.filterMod.hasOwnProperty("assign_to")) {
              newval = [...this.state.filterMod.assign_to];
              columns = [...this.state.selectColumnsCheck];
            } else {
              newval = [commonData.getCommonData().user_uuid];
              columns = ["assign_to"];
            }

            setTimeout(() => {
              this.setState(
                (state) => {
                  return {
                    ...state,
                    filterMod: {
                      ...state.filterMod,
                      assign_to: newval,
                    },
                    selectColumnsCheck: columns,
                  };
                },
                () => {
                  this.storeFilterInLocal({
                    ...this.state.filterMod,
                  });
                },
              );
            }, 100);
          }
          const getfilterval =
            this.getDataFromLocalStorage()[
              this.props.match.params.attribute_set_key
            ];
          let dataparse = [];
          if (getfilterval) {
            dataparse = Object.keys(JSON.parse(getfilterval));
          }
          let selectedfilter = localStorage.getItem("selected_filter");
          const selecteFil = this.IsJsonString(selectedfilter)
            ? JSON.parse(selectedfilter)
            : "";

          let newioo;
          if (
            this.props.match.params.selectedFilterId &&
            !selecteFil?.[this.props.match.params.attribute_set_key] &&
            Object.keys(this.state.filterMod).length === 0
          ) {
            const { system_filter } = this.state.boarddata?.filter;
            const filtervaluefilter = system_filter.find(
              (it) =>
                it?.filter_id === this.props.match.params.selectedFilterId,
            );

            if (
              filtervaluefilter &&
              this.IsJsonString(filtervaluefilter?.filter_value)
            ) {
              const valueparse = JSON.parse(filtervaluefilter?.filter_value);
              this.storeFilterInLocal({
                selected_filter: this.props.match.params.selectedFilterId,
              });

              setTimeout(() => {
                this.setState({
                  ...this.state,
                  filterMod: { ...valueparse, ...this.state.filterMod },
                });
              }, 100);
            } else {
              this.storeFilterInLocal({ selected_filter: selectedfilter });
            }
          }
          if (selectedfilter) {
            if (this.IsJsonString(selectedfilter)) {
              const newidobj = JSON.parse(selectedfilter || {})[
                this.props.match.params.attribute_set_key
              ];
              newioo = newidobj;
            } else {
              this.storeFilterInLocal({ selected_filter: selectedfilter });
            }
          }
          if (
            dataparse?.length === 0 &&
            !this.state.customSearch &&
            !isFilterReset[this.props.match.params.attribute_set_key] &&
            this.state.boarddata?.filter?.system_filter.length > 0 &&
            !newioo
          ) {
            const defaultFilter = !this.props.match.params
              .second_attribute_set_key
              ? this.state.boarddata?.filter?.system_filter.filter(
                  (item) => item.is_default,
                )
              : {};
            if (
              defaultFilter.length > 0 &&
              !this.props.match.params.selectedFilterId
            ) {
              const filterMod = JSON.parse(
                defaultFilter?.[0]?.filter_value ?? "{}",
              );
              this.setState({ ...this.state, filterMod: filterMod }, () => {
                this.getFilteredObj({
                  ...defaultFilter?.[0],
                  selected_filter: defaultFilter?.[0].filter_id,
                });
              });
              return;
            }
          } else {
            const selectedFilter =
              this.getDataFromLocalStorage()[
                this.props.match.params.attribute_set_key
              ];
            if (this.state.boarddata.attribute_set_type != 4) {
              const getselectedFilter = localStorage.getItem("selected_filter");
              let selectedfilter = "";
              if (getselectedFilter && this.IsJsonString(getselectedFilter)) {
                let parsedata = JSON.parse(getselectedFilter);
                selectedfilter =
                  parsedata[this.props.match.params.attribute_set_key];
              }
              const filterMod = JSON.parse(selectedFilter || "{}");
              let newurl = new URLSearchParams(window.location.search).get("q");

              if (!newurl) {
                setTimeout(() => {
                  this.setState(
                    {
                      ...this.state,
                      filterMod: { ...filterMod, ...this.state.filterMod },
                    },
                    () => {
                      // this.storeFilterInLocal(
                      //   {
                      //     ...this.state.filterMod,
                      //     selected_filter: selectedfilter,
                      //   },
                      //   this.state.advance_filter
                      // );
                    },
                  );
                }, 100);
              }
            }
          }
          var title = this.props.title ? this.props.title : "";
          document.title = `${
            this.state.boarddata.attribute_set_name || ""
          } | ${title}`;
          this.props.checkSidebarLink(
            this.props.match.params.attribute_set_key,
          );

          if (
            params?.colDef?.field &&
            this.state.selectColumnsCheck.includes(params?.colDef?.field)
          ) {
            const check = document.querySelector(
              `[col-id="${params.column.colId}"]`,
            );
            check.querySelectorAll(".filter-svg path").forEach((ite) => {
              return {
                ...(ite.style.stroke = "#18A0FB"),
                ...(ite.style.fill = "#18A0FB"),
              };
            });
            check.querySelectorAll(".filter-svg").forEach((ite) => {
              return {
                ...(ite.style.stroke = "#18A0FB"),
                ...(ite.style.fill = "#18A0FB"),
              };
            });
          } else if (
            params?.colDef?.field &&
            this.state.selectColumnsCheck.includes(params?.colDef?.field) ===
              false
          ) {
            const check = document.querySelector(
              `[col-id="${params.column.colId}"]`,
            );

            check
              .querySelectorAll(".filter-svg path")
              .forEach((ite) => ite.setAttribute("stroke", "grey"));
            check.querySelectorAll(".filter-svg path").forEach((ite) => {
              return {
                ...ite.removeAttribute("style"),
                ...ite.setAttribute("stroke", "gray"),
                ...ite.setAttribute("fill", "gray"),
              };
            });
          }
          const querydata = document.querySelectorAll(".filter-svg path");

          querydata.forEach((itt) => {
            return {
              ...itt.removeAttribute("style"),
              ...itt.setAttribute("stroke", "gray"),
              ...itt.setAttribute("fill", "gray"),
            };
          });
          if (this.state.selectColumnsCheck.length === 0) {
            document
              .querySelectorAll(".filter-svg path")
              .forEach((ite) => (ite.stroke = "gray"));
            document.querySelectorAll(".filter-svg path").forEach((ite) => {
              return {
                ...ite.removeAttribute("style"),
                ...ite.setAttribute("stroke", "gray"),
                ...ite.setAttribute("fill", "gray"),
              };
            });
          }
          document
            .querySelectorAll(`.filter-svg path`)
            .forEach((ite) => (ite.style.stroke = "grey"));
          document.querySelectorAll(`.filter-svg path`).forEach((ite) => {
            return {
              ...ite.removeAttribute("style"),
              ...ite.setAttribute("stroke", "gray"),
              ...ite.setAttribute("fill", "gray"),
            };
          });

          this.state.selectColumnsCheck.forEach((item) => {
            const check = document.querySelector(`[col-id="${item}"]`);
            if (check && check.querySelector(`.filter-svg path`)) {
              check
                .querySelectorAll(`.filter-svg path`)
                .forEach((ite) => (ite.style.stroke = "#18A0FB"));
            }
          });
          this.setState({ ...this.state, gridapi: params });

          if (!this.gridApi) {
            this.getgridapi.current?.api?.setServerSideDatasource(
              this.datasource,
            );
            return;
          } else {
            this.gridApi?.setServerSideDatasource(this.datasource);
            return;
          }
        },
      );
    }
  };

  getRowClass = (row) => {
    const { data } = row;

    if (data?.sla_missed) {
      return "row_sla_missed";
    }
  };

  checkAdmin = () => {};
  showcolumnsVisible = () => {
    this.setState({ ...this.state, showHideColu: true });
  };

  //show the hide columns

  inputChangeCheckbox = (event) => {
    const { name, checked } = event.target;
    const hiddenColumns = [...this.state.hidden_columns];
    const cols = hiddenColumns.map((check) =>
      check.field === name
        ? { ...check, show_on_column: checked, show_on_form: checked }
        : { ...check },
    );

    const boardDetails = {
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.attribute_set_key,
      attributes: [name],
      status_type: checked ? "show" : "hide",
    };
    let rees;
    if (checked) {
      rees = this.props.showColumns(boardDetails);
    } else {
      rees = this.props.hideColumn(boardDetails);
    }
    let columnsfetch = {
      key:
        this.props.match.params.second_attribute_set_key ??
        this.props.match.params.attribute_set_key,
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
    };
    this.props.fetchAllColumns(columnsfetch);
    // console.log(rees, "resfdsddes");
    // this.setState({ ...this.state, hidden_columns: cols });
  };

  searchGrid = (event) => {
    const { name, value } = event.target;
    this.setState(
      { ...this.state, agGridStateUpdate: false, globalSearch: value },
      () => {
        // Get existing filter object or initialize empty one
        let mergingtitle = {};
        const localfilterdata = localStorage.getItem("filter");

        if (localfilterdata) {
          try {
            mergingtitle = JSON.parse(localfilterdata);
          } catch (e) {
            console.error("Invalid JSON in localStorage:", e);
          }
        }

        // Dynamic key from props
        const key = this.props.match.params.attribute_set_key;

        // Build the object you want to stringify
        const innerObject = {
          search: value, // `value` should be your title string
        };

        // Stringify and assign it
        mergingtitle[key] = JSON.stringify(innerObject);

        // Save to localStorage
        localStorage.setItem("filter", JSON.stringify(mergingtitle));

        if (this.getgridapi.current) {
          if (this.timeframe) {
            clearTimeout(this.timeframe);
          }
          this.timeframe = setTimeout(() => {
            this.onGridReady(this.getgridapi.current);
            if (this.searchTimeFrame) {
              clearTimeout(this.searchTimeFrame);
            }
            this.searchTimeFrame = setTimeout(() => {
              // console.log(this.searchRef, 'searchRef');
              this.searchRef.current?.focus();
            }, 2000);
          }, 1000);
        }
      },
    );
  };

  editperpage = () => {
    const editdata = { ...this.state.perPage };
    editdata.editpagesize = true;

    this.setState({ ...this.state, perPage: editdata }, () => {
      if (this.paginationchnage) {
        this.paginationchnage.current.focus();
      }
    });
  };

  paginationSizeChange = (ev) => {
    this.setState(
      {
        ...this.state,
        perPage: {
          ...this.state.perPage,
          pagination_default_value: ev.target.value,
        },
      },
      () => {
        this.gridApi.paginationSetPageSize(
          this.state.perPage.pagination_default_value,
        );
      },
    );
  };

  onColumnResized = (params) => {
    if (params.source === "uiColumnDragged") {
      const columnspropetise = params.column?.colDef;
      const formvalues = {
        ...columnspropetise,
        width: params.column?.actualWidth || 275,
      };
      const { options, ...newoptions } = formvalues;
      const boardDetails = {
        app_token: this.state.boarddata.app_token,
        user_uuid: this.state.boarddata.user_uuid,
        attribute_set_key: this.props.match.params.attribute_set_key,
        attributes: [formvalues.field],
        width: newoptions?.width,
      };

      if (this.interval) {
        clearTimeout(this.interval);
      }
      this.interval = setTimeout(() => {
        this.props.columnResize(boardDetails);
      }, 200);

      this.setState({ ...this.state, formvalues: formvalues }, () => {});
    } else {
      return;
    }
  };

  showAttributeListDropDown = () => {
    this.setState({ ...this.state, showattrdrop: true });
  };

  hideattrdrop = () => {
    this.setState({ ...this.state, showattrdrop: false });
  };
  onRowSelected = (event) => {
    if (!event) return;
    const { data, api, node } = event;
    if (api) {
      this.gridApi = api;
    }

    const currentSelected = Array.isArray(this.state.selectedrowsdata)
      ? [...this.state.selectedrowsdata]
      : [];

    if (data?.customer_tattle_uuid) {
      const isSelected = node?.isSelected ? node.isSelected() : false;
      const index = currentSelected.findIndex(
        (it) => it?.customer_tattle_uuid === data.customer_tattle_uuid,
      );

      if (index > -1 && !isSelected) {
        currentSelected.splice(index, 1);
      } else if (index === -1 && isSelected) {
        currentSelected.push(data);
      }
    }

    const gridSelected =
      api?.getSelectedRows?.() ||
      this.gridApi?.getSelectedRows?.() ||
      this.getgridapi.current?.api?.getSelectedRows?.();

    const selectedRows =
      Array.isArray(gridSelected) && gridSelected.length > 0
        ? gridSelected
        : currentSelected;

    this.setState({
      selectedrowsdata: Array.isArray(selectedRows) ? selectedRows : [],
    });

    setTimeout(() => {
      const deferredSelected =
        api?.getSelectedRows?.() ||
        this.gridApi?.getSelectedRows?.() ||
        this.getgridapi.current?.api?.getSelectedRows?.();

      if (Array.isArray(deferredSelected)) {
        this.setState({
          selectedrowsdata: deferredSelected,
        });
      }
    }, 50);
  };

  showClumnByCheckbox = (datain) => {
    const hidecolumns = [...this.state.columnsHide];
    const showcolumns = [...this.state.showAttrCheck];
    const showcol = hidecolumns.splice(datain, 1);
    showcolumns.push(showcol);
    this.setState(
      { ...this.state, showAttrCheck: showcolumns, columnsHide: hidecolumns },
      () => {
        this.columnApi.setColumnsVisible(this.state.showAttrCheck, true);
      },
    );
  };
  showboardpopup = (board) => {
    this.setState({
      ...this.state,
      createBoard: {
        ...this.state.createBoard,
        board: board.board,
        message: board.message,
        bg: board.bg,
        title: board.title,
      },
    });
  };
  onFirstDataRendered = (params) => {
    // window.setTimeout(() => {
    //   const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
    //   params.columnApi.autoSizeColumns(colIds);
    // }, 50);
  };
  resetAllFilter = () => {
    this.setState(
      {
        ...this.state,
        filterMod: {},
        resetFilter: true,
        isReset: true,
        default_filter: [],
        agGridStateUpdate: false,
        selectColumnsCheck: [],
        selectedFilter: "",
        isActiveTodoFilter: false,
        globalSearch: "",
        advance_filter: [],
        filterName: "",
      },
      () => {
        this.getDataFromLocalStorage("delete");
        let resetdata = {
          [this.props.match.params.attribute_set_key]: true,
        };
        this.props.isFilterReset(resetdata);
        let columnsfetch = {
          key:
            this.props.match.params.second_attribute_set_key ??
            this.props.match.params.attribute_set_key,
          app_token: this.state.boarddata.app_token,
          user_uuid: this.state.boarddata.user_uuid,
        };
        window.history.replaceState(null, "");
        this.props.fetchAllColumns(columnsfetch);
        this.getgridapi.current?.api?.setServerSideDatasource(this.datasource);
      },
    );
  };
  getDataFromLocalStorage = (key = null) => {
    if (key === "delete") {
      localStorage.removeItem("selected_filter");
      let getdatafromstorage = this.state.filterType
        ? JSON.parse(localStorage.getItem("advance_filter"))
        : JSON.parse(localStorage.getItem("filter"));
      //      let getdatafromstorage = JSON.parse(localStorage.getItem("filter"));
      const getpath = this.props.match.url.split("/")?.[2];
      if (getdatafromstorage?.hasOwnProperty(getpath)) {
        delete getdatafromstorage[getpath];
        if (this.state.filterType) {
          localStorage.setItem(
            "advance_filter",
            JSON.stringify(getdatafromstorage),
          );
        } else {
          localStorage.setItem("filter", JSON.stringify(getdatafromstorage));
        }
        //        localStorage.setItem("filter", JSON.stringify(getdatafromstorage));
        return;
      }
    }
    if (this.state.filterType) {
      let getdatafromstorage = JSON.parse(
        localStorage.getItem("advance_filter") || "{}",
      );
      return getdatafromstorage;
    } else {
      let getdatafromstorage = JSON.parse(
        localStorage.getItem("filter") || "{}",
      );
      return getdatafromstorage;
    }
    //    let getdatafromstorage = JSON.parse(localStorage.getItem("filter") || "{}");

    //    return getdatafromstorage;
  };

  storeFilterInLocal = (filter, advance_filter) => {
    let filterInLocal = {};
    let { selected_filter, ...rest } = filter;
    let newfilter = JSON.stringify(rest);

    if (this.state.filterType) {
      newfilter = JSON.stringify(advance_filter);
    }
    let getdatafromstorage = this.getDataFromLocalStorage();
    const getselectedFilter = localStorage.getItem("selected_filter");

    let selectedFiltrObj = {};
    if (getselectedFilter && this.IsJsonString(getselectedFilter)) {
      const parsejson = JSON.parse(getselectedFilter);
      selectedFiltrObj = {
        ...selectedFiltrObj,
        ...parsejson,
        [this.props.match.params.attribute_set_key]: selected_filter,
      };
    } else {
      selectedFiltrObj = {
        ...selectedFiltrObj,
        [this.props.match.params.attribute_set_key]: selected_filter,
      };
    }

    filterInLocal = {
      ...filterInLocal,
      [this.props.match.params.attribute_set_key]: newfilter,
    };

    getdatafromstorage = { ...getdatafromstorage, ...filterInLocal };
    //    console.log(2236, getdatafromstorage);
    if (this.state.filterType) {
      localStorage.setItem(
        "advanced_filter",
        JSON.stringify(getdatafromstorage),
      );
    } else {
      localStorage.setItem("filter", JSON.stringify(getdatafromstorage));
    }
    localStorage.setItem("selected_filter", JSON.stringify(selectedFiltrObj));
  };
  getAddToButton = () => {
    if (
      this.state.boarddata.attribute_set_type == 4 ||
      this.state.boarddata.attribute_set_type == 10
    ) {
      return (
        <div class="icon-before font-weight-bold">
          <button className="muBtn _blue" onClick={this.showAddTodoCanvas}>
            <span class="svg" style={{ width: "17px" }}>
              <PlusSvg />
            </span>{" "}
            Add {this.state.boarddata.attribute_set_name}
          </button>
        </div>
      );
    }
    return (
      <div class="icon-before font-weight-bold">
        <Link
          to={{
            pathname: `/tattle/${this.props.match.params.second_attribute_set_key ?? this.props.match.params.attribute_set_key}/add`,
          }}
          className="muBtn _blue"
        >
          <span class="svg" style={{ width: "17px" }}>
            <PlusSvg />
          </span>{" "}
          Add{" "}
          {this.props.match.params.second_attribute_set_key
            ? this.props.match.params.second_attribute_set_key
            : this.state.boarddata.attribute_set_name}
        </Link>
      </div>
    );
  };
  submitBulkUpdate = async (data) => {
    this.setState((state) => {
      return {
        ...state,
        isBulkUpload: true,
      };
    });
    const updatedata = {
      ...data,
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.attribute_set_key,
    };
    try {
      const resdata = await bulkupdateData.bulkUpdate(updatedata);

      if (resdata.code === 200) {
        // Check if any attribute_type is "project" to enable progress polling
        const hasProjectType = data.attribute_types
          ? Object.values(data.attribute_types).includes("project")
          : false;

        if (hasProjectType) {
          // Store tracking info in localStorage for resume-on-refresh
          const progressKey = `bulk_progress_${this.props.match.params.attribute_set_key}`;
          const trackingData = {
            app_token: this.state.boarddata.app_token,
            user_uuid: this.state.boarddata.user_uuid,
            attribute_set_key: this.props.match.params.attribute_set_key,
            unique_id: resdata.unique_id || null,
          };
          localStorage.setItem(progressKey, JSON.stringify(trackingData));

          this.setState(
            (state) => {
              return {
                ...state,
                bulkUpdateDone: !this.state.bulkUpdateDone,
                isBulkUpload: false,
                bulkProgressActive: true,
                bulkProgressPercent: 0,
              };
            },
            () => {
              this.startBulkProgressPolling(trackingData, progressKey);
            },
          );
          this.getgridapi.current.api.deselectAll();
        } else {
          this.setState(
            (state) => {
              return {
                ...state,
                bulkUpdateDone: !this.state.bulkUpdateDone,
                isBulkUpload: false,
              };
            },
            () => {
              setTimeout(() => {
                this.onGridReady(this.getgridapi.current);
              }, 2000);
            },
          );
          this.getgridapi.current.api.deselectAll();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // startBulkProgressPolling = (trackingData, progressKey) => {
  //   // Clear any existing interval
  //   if (this.bulkProgressInterval) {
  //     clearInterval(this.bulkProgressInterval);
  //   }

  //   this.bulkProgressInterval = setInterval(async () => {
  //     try {
  //       const progressRes = await bulkupdateData.checkBulkProgress(trackingData);

  //       if (progressRes && progressRes.code === 200 && progressRes.data) {
  //         const { status, percentage } = progressRes.data;

  //         this.setState({ bulkProgressPercent: percentage || 0 });

  //         if (status === "completed" || status === "not_found" || percentage >= 100) {
  //           // Clear interval and remove localStorage key
  //           clearInterval(this.bulkProgressInterval);
  //           this.bulkProgressInterval = null;
  //           localStorage.removeItem(progressKey);

  //           this.setState(
  //             {
  //               bulkProgressActive: false,
  //               bulkProgressPercent: 100,
  //             },
  //             () => {
  //               // Refresh the grid after completion
  //               setTimeout(() => {
  //                 this.setState({ bulkProgressPercent: 0 });
  //                 this.onGridReady(this.getgridapi.current);
  //               }, 1000);
  //             },
  //           );
  //         }
  //       }
  //     } catch (error) {
  //       console.log("Bulk progress polling error:", error);
  //     }
  //   }, 3000);
  // };


startBulkProgressPolling = (trackingData, progressKey) => {

  // Clear existing interval and timeout
  if (this.bulkProgressInterval) {
    clearInterval(this.bulkProgressInterval);
  }

  if (this.bulkProgressTimeout) {
    clearTimeout(this.bulkProgressTimeout);
  }

  let isCompleted = false;
  let redisQueueTriggered = false;

  console.log("Bulk progress polling started");

  // Trigger Redis queue API after 15 seconds
  this.bulkProgressTimeout = setTimeout(async () => {


    if (!isCompleted && !redisQueueTriggered) {

      redisQueueTriggered = true;

      try {

        const response = await bulkupdateData.processRedisQueue();


      } catch (error) {
        console.error(
          "Redis queue processing error:",
          error?.message || error
        );
      }
    }

  }, 15000);


  // Poll progress every 3 seconds
  this.bulkProgressInterval = setInterval(async () => {

    if (isCompleted) return;

    try {

      const progressRes =
        await bulkupdateData.checkBulkProgress(trackingData);

      console.log("Bulk progress response:", progressRes);

      if (progressRes?.code === 200 && progressRes.data) {

        const { status, percentage } = progressRes.data;

        this.setState({
          bulkProgressPercent: percentage || 0
        });

        // IMPORTANT:
        // not_found is considered pending, not completed.
        if (status === "completed" || Number(percentage) >= 100) {

          isCompleted = true;

          clearInterval(this.bulkProgressInterval);
          clearTimeout(this.bulkProgressTimeout);

          this.bulkProgressInterval = null;
          this.bulkProgressTimeout = null;

          localStorage.removeItem(progressKey);

          this.setState({
            bulkProgressActive: false,
            bulkProgressPercent: 100
          }, () => {

            setTimeout(() => {
              this.setState({
                bulkProgressPercent: 0
              });

              this.onGridReady(this.getgridapi.current);

            }, 1000);

          });

        } else {

          console.log("Bulk processing status:", status);

        }
      }

    } catch (error) {

      console.error(
        "Bulk progress polling error:",
        error.response?.data || error.message
      );

    }

  }, 3000);

};



  updateAttrType = (types) => {
    setTimeout(() => {
      this.setState((prevState) => {
        return {
          ...prevState,
          formvalues: { ...prevState.formvalues, ...types },
        };
      });
    }, 10);
  };
  submitAdvFilterHandler = (filter) => {
    this.setState(
      { ...this.state.advance_filter, ...filter, agGridStateUpdate: false },
      function () {
        // console.log(2334, this.state.advance_filter);
      },
    );
    this.storeFilterInLocal(filter);
    this.onGridReady(this.getgridapi.current);
  };

  submitFilterHandler = (filter) => {
    let newkey = Object.keys(filter);

    let newfilter = { ...this.state.filter, ...filter };
    const { filter_id, ...rest } = newfilter;
    for (let key in newfilter) {
      if (
        (newfilter.hasOwnProperty(key) && !newfilter[key]) ||
        (Array.isArray(newfilter[key]) && !newfilter[key].length > 0)
      ) {
        delete newfilter[key];
        let findindex = newkey.indexOf(key);
        newkey.splice(findindex, 1);
      }
    }

    newkey = newkey.flatMap((item) => {
      if (item === "customer_name") {
        return "name";
      } else if (item === "range") {
        return Object.keys(filter[item]);
      } else {
        return item;
      }
    });

    this.setState(
      (state) => {
        return {
          ...state,
          filterMod: rest,
          selectColumnsCheck: newkey,
          agGridStateUpdate: false,
          isReset: !this.state.isReset,
        };
      },
      () => {
        this.storeFilterInLocal({
          ...this.state.filterMod,
          selected_filter: filter.filter_id,
        });
        this.onGridReady(this.getgridapi.current);
      },
    );
  };

  closeModal = () => {
    this.setState((state) => {
      return {
        ...state,
        isFilterCreate: false,
      };
    });
  };
  showIsKanban = () => {
    this.setState((state) => {
      return {
        ...state,
        isShowKanban: !this.state.isShowKanban,
      };
    });
  };

  removeUndefinedKeys = (obj) => {
    for (const key in obj) {
      if (obj[key] === undefined) {
        delete obj[key];
      } else if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
        // Recursively check nested objects
        this.removeUndefinedKeys(obj[key]);
      }
    }
    return obj;
  };

  isFilterCreate = (args = "") => {
    //      console.log(2421,args)
    //      console.log(2421,state.filterMod)

    let newfilterdata = { ...args };

    let {
      qa_start_date,
      qa_end_date,
      start_date,
      end_date,
      date,
      go_live_date,
      ...rest
    } = newfilterdata;

    if (rest.hasOwnProperty("range")) {
      newfilterdata = {
        ...rest,
        range: {
          qa_start_date,
          qa_end_date,
          start_date,
          date,
          end_date,
          go_live_date,
          ...rest.range,
        },
      };
    } else {
      newfilterdata = {
        ...rest,
        range: {
          qa_start_date,
          qa_end_date,
          start_date,
          end_date,
          go_live_date,
          ...rest.range,
        },
      };
    }
    this.setState(
      (state) => {
        return {
          ...state,
          isFilterCreate: true,
          filterMod: {
            ...this.removeUndefinedKeys(newfilterdata),
          },
          filterType: 0,
        };
      },
      () => {
        // console.log(this.state.filterMod, 875687673246372);
      },
    );
  };

  isAdvFilterCreate = (args = "", filter_id) => {
    this.setState(
      (state) => {
        return {
          ...state,
          isFilterCreate: this.state.isEdit ? false : true,
          //        isFilterCreate: true,
          filterType: 1,
          advance_filter: args,
        };
      },
      function () {
        if (this.state.isEdit) {
          this.createFilterByView(args, filter_id);
        } else {
          this.createFilterByView(args);
        }
      },
    );
  };

  submitRenameBoard = (evt) => {
    if (this.state.currentBoardName !== evt.target.defaultValue) {
      this.inlineBoardNameChange(evt);
    } else {
      newkey = newkey.map((item) =>
        item === "customer_product"
          ? "product"
          : item === "custom_effort"
            ? "effort"
            : item,
      );
      this.setState({ ...this.state, editiBoard: false });
    }
  };

  openNoteHandler = (id) => {
    this.setState(
      (state) => {
        return {
          ...state,
          showTodoNote: true,
          todoCustomerTattleId: id,
          notes: [],
          isLoading: true,
        };
      },
      async () => {
        let jsondata = {
          app_token: this.state.boarddata.app_token,
          attribute_set_key: this.props.match.params.attribute_set_key,
          attribute_set_type: this.state.boarddata.attribute_set_type,
          customer_tattle_uuid: id,
          order: "asc",
        };
        const resp = await fetch(`${this.state.apiUrl}notes/list`, {
          method: "post",
          body: JSON.stringify(jsondata),
        });
        const rdata = await resp.json();
        if (rdata.code === 200) {
          this.setState((state) => {
            return {
              ...state,
              notes: rdata.data || [],
              isLoading: false,
            };
          });
        } else {
          this.setState((state) => {
            return {
              ...state,
              notes: rdata.data || [],
              isLoading: false,
            };
          });
        }
      },
    );
  };
  createTableCustomFilter = (evt) => {
    if (evt.__isNew__) {
      this.setState((state) => {
        return {
          ...state,
          enableCustomFilter: true,
          filterText: evt.label,
        };
      });
    } else {
      const filterConvert = JSON.parse(evt.value);
      const getKeys = Object.keys(filterConvert);
      this.setState(
        (state) => {
          return {
            ...state,
            selectColumnsCheck: getKeys,
            filterMod: { ...filterConvert },
          };
        },
        () => {
          this.onGridReady(this.getgridapi.current);
        },
      );
    }
  };
  perPageSizeChange = (evet) => {
    this.setState(
      (state) => {
        return {
          ...state,
          perPageSizeChange: evet.target.value,
        };
      },
      () => {
        this.onGridReady(this.getgridapi.current);
      },
    );
  };

  createFilterByView = async (arg = "", id = "") => {
    let newfilter = { ...arg };
    for (let key in newfilter) {
      if (
        (newfilter.hasOwnProperty(key) && !newfilter[key]) ||
        (Array.isArray(newfilter[key]) && !newfilter[key].length > 0)
      ) {
        delete newfilter[key];
      }
    }
    const filtersData = {
      app_token: this.state.boarddata.app_token,
      attribute_set_key: this.props.match.params.attribute_set_key,
      user_uuid: this.state.boarddata.user_uuid,
      filter_name: this.state.filterText,
      //      filter_value: { ...this.state.filterMod },
      filter_value: this.state.filterType
        ? this.state.advance_filter
        : { ...this.state.filterMod },
      is_system: 0,
      filter_type: this.state.filterType ? this.state.filterType : 0,
    };
    if (this.state.isEdit) {
      const filterData = {
        ...this.state.editFilterValues,
        filter_value: JSON.stringify({ ...this.state.filterMod }),
      };
      const customFilter = [...this.state.customFilter];
      const newEditFilter = {
        filter_id: filterData.filter_id,
        filter_name: filterData.filter_name,
        filter_value: this.state.filterType
          ? this.state.advance_filter
          : { ...newfilter },
        is_system: filterData.is_system,
        is_default: filterData.is_default,
        filter_type: this.state.filterType ? this.state.filterType : 0,
      };
      const objKeys = Object.keys(newfilter);

      this.setState(
        {
          ...this.state,
          filterpopup: false,
          selectColumnsCheck: objKeys,
          agGridStateUpdate: false,
          filterMod: { ...newfilter },
        },
        () => {
          this.storeFilterInLocal({
            ...newEditFilter.filter_value,
            selected_filter: filterData.filter_id,
          });
          this.props.editFilter(newEditFilter);
          this.setState({ ...this.state, isReset: !this.state.isReset });
          this.onGridReady(this.getgridapi.current);
        },
      );
    } else {
      const resp = await fetch(`${this.state.apiUrl}create-custom-filter`, {
        method: "post",
        body: JSON.stringify(filtersData),
      });
      const rdata = await resp.json();
      if (rdata.code === 200) {
        const filterCustom = [...this.state.customFilter];
        filterCustom.push({
          label: this.state.filterText,
          value: JSON.stringify(this.state.filterMod),
        });
        this.setState((state) => {
          return {
            ...state,
            filterText: "",
            customFilter: filterCustom,
            agGridStateUpdate: false,
            createBoard: {
              ...state.createBoard,
              board: true,
              title: "success",
              message: "Filter Created Successfully",
              position: "bottom-end",
              status: "success",
              bg: "primary",
            },
          };
        });
      }
    }
  };
  getRawData = async (data, html, draft_js_content, images = []) => {
    this.setState((state) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    // const formdata = new FormData();
    // formdata.append(
    //   "attribute_set_key",
    //   this.props.match.params.attribute_set_key
    // );
    // formdata.append("app_token", this.state.boarddata.app_token);
    // formdata.append("customer_tattle_uuid", +this.state.todoCustomerTattleId);
    // formdata.append("user_uuid", this.state.boarddata.user_uuid);
    // formdata.append("note_content", html);
    // formdata.append("note_content_json", data);
    // formdata.append(
    //   "attribute_set_type",
    //   this.state.boarddata.attribute_set_type
    // );
    // formdata.append("note_type", "internal");
    // if (Object.keys(images).length > 0) {
    //   formdata.append("attachment", JSON.stringify(images));
    // }
    let formdata = {};

    formdata = {
      attribute_set_key: this.props.match.params.attribute_set_key,
      app_token: this.state.boarddata.app_token,
      customer_tattle_uuid: +this.state.todoCustomerTattleId,
      user_uuid: this.state.boarddata.user_uuid,
      note_content: html,
      note_content_json: data,
      attribute_set_type: this.state.boarddata.attribute_set_type,
    };

    const response = await fetch(`${this.state.apiUrl}note/create`, {
      method: "post",
      body: JSON.stringify(formdata),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      let allnotes = [...this.state.notes];
      allnotes.push(rdata.data);
      this.setState(
        (state) => {
          return {
            ...state,
            notes: allnotes || [],
            isLoading: false,
          };
        },
        async () => {
          let notesData = {
            app_token: this.state.boarddata.app_token,
            attribute_set_key: this.props.match.params.attribute_set_key,
            customer_tattle_uuid: +this.state.todoCustomerTattleId,
          };
          const resp = await fetch(`${this.state.apiUrl}notes/list`, {
            method: "post",
            body: JSON.stringify(notesData),
          });
          const jsonResp = await resp.json();
          if (jsonResp.code === 200) {
            this.setState((state) => {
              return {
                ...state,
                // users: jsonResp.users,
              };
            });
          }
        },
      );
    }
  };

  getNoteDetails = (item) => {
    if (item.hasOwnProperty("user_details")) {
      return (
        <>
          {item.user_details?.profile_url && item.userDetails?.name ? (
            <a
              target={"_blank"}
              href={item?.user_details?.profile_url}
              className="checkUserNameNote"
            >
              {" "}
              {item?.user_details?.name}
            </a>
          ) : (
            <a
              target={"_blank"}
              href={
                this.state.users[item?.user_uuid]?.profile_url
                  ? this.state.users[item?.user_uuid]?.profile_url
                  : ""
              }
              className="checkUserNameNote"
            >
              {this.state.users[item?.user_uuid]?.name}
            </a>
          )}
          {this.props.match.params.attribute_set_key === "support-ticket" && (
            <span>Internal</span>
          )}
        </>
      );
    }

    const user = this.state.users;

    return (
      <>
        {user?.[item?.user_uuid]?.profile_url ? (
          <a
            target={"_blank"}
            href={user?.[item.user_uuid]?.profile_url}
            className="checkUserNameNote"
          >
            {" "}
            {user?.[item.user_uuid]?.name}
          </a>
        ) : (
          <a
            target={"_blank"}
            href={
              this.state.users?.[item?.user_uuid]?.profile_url
                ? this.state.users?.[item?.user_uuid]?.profile_url
                : ""
            }
            className="checkUserNameNote"
          >
            {this.state.users[item?.user_uuid]?.name}
          </a>
        )}
        {this.props.match.params.attribute_set_key === "support-ticket" && (
          <span>Internal</span>
        )}
      </>
    );
  };
  getNoteListHandler = () => {
    if (this.state.isLoading && this.state.notes.length === 0) {
      return (
        <div className="details-fullpageAddTodo-loading">
          <Loading />
        </div>
      );
    }
    if (this.state.notes.length === 0) {
      return (
        <div className="notes_parents">
          <div className="No_notes_parents">
            <div class="card-body no-content">
              <div class="svg reset">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                  width="50px"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
                  />
                </svg>
              </div>
              <div class="title mt-3">No Notes found</div>
              <div class="sub-title">Your Notes will show up here.</div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="details-fullpageAddTodo">
        <div className="editNoteContent">
          <div className="addNote-Self">
            <div class="row justify-content-start" id="note335057">
              {this.state.notes.map((item, index) => {
                let image;
                if (this.state.users) {
                  image = this.state.users[item.user_uuid]?.profile_image;
                } else {
                  image = item?.user_details?.profile_image;
                }
                return (
                  <div class="col-lg-12 mt-3">
                    <div class="self-singlebox">
                      <div className="d-flex justify-content-between align-items-center">
                        <div class="topPart d-flex justify-content-start align-items-center">
                          <div class="left-side firstLetter">
                            <img src={`${image}`} />
                          </div>
                          <div class="right-side">
                            <div class="name">{this.getNoteDetails(item)}</div>

                            <div class="noteDesc self">
                              {this.getNoteLink(
                                item,
                                this.props.match.params.attribute_set_key,
                                this.state.boarddata?.attribute_set_type,
                              )}
                              {moment(item?.created_at).format(
                                process.env.REACT_APP_DATE_TIME_FORMAT,
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="reasonsec">
                        {item?.hasOwnProperty("reason") &&
                          Object.keys(item.reason).length > 0 &&
                          Object.keys(item.reason).map((nitem) => {
                            return (
                              <li>
                                <strong>{nitem} </strong>: {item.reason[nitem]}
                              </li>
                            );
                          })}
                      </div>
                      <div
                        class="note-text"
                        dangerouslySetInnerHTML={{
                          __html: item?.note_content,
                        }}
                      ></div>
                    </div>
                  </div>
                );
              })}
              <div ref={this.scrollRef}></div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  getNoteTodoView = () => {
    let returnNoteTodo;

    returnNoteTodo = (
      <div className="manageTodoNote">
        {this.getNoteListHandler()}

        <div className="todoNote">
          <Error>
            <Note
              getRawData={this.getRawData}
              users={this.state.users || {}}
              addnote={true}
              toolbar={true}
              isAdding={""}
              buttonDisabled={this.state.isLoading}
            />
          </Error>
        </div>
      </div>
    );

    return returnNoteTodo;
  };
  attributeHandlerChanges = (evt, field, type) => {
    if (type === "priority") {
      this.setState((state) => {
        return {
          ...state,
          editData: { [field]: evt },
        };
      });
      return;
    } else if (type == "text") {
      const { name, value } = evt.target;
      this.setState((state) => {
        return {
          ...state,
          editData: { ...state.editData, newValue: value },
        };
      });
    } else if (type === "api") {
      this.setState((state) => {
        return {
          ...state,
          editData: { [field]: evt },
        };
      });
      return;
    } else if (type == "category") {
      this.setState((state) => {
        return {
          ...state,
          editData: { [field]: evt },
        };
      });
      return;
    } else if (
      type === "date" ||
      type === "start_date" ||
      type === "end_date" ||
      type === "go_live_date"
    ) {
      this.setState((state) => {
        return {
          ...state,
          editData: { ...state.editData, newValue: new Date(evt) },
        };
      });
    } else {
      this.setState((state) => {
        return {
          ...state,
          editData: { ...state.editData, newValue: evt },
        };
      });
    }
  };
  removeFilterConfirmHandler = () => {
    this.props.removeFilter(this.state.removeFilterId);
    this.setState({
      ...this.state,
      filterpopup: false,
      isReset: !this.state.isReset,
    });
    this.getDataFromLocalStorage("delete");
    let getselectfilterid = localStorage.getItem("selected_filter");
    if (getselectfilterid == this.state.removeFilterId) {
      this.onGridReady(this.getgridapi.current);
    }
  };
  removeFilterHandler = (id, filter_type) => {
    this.setState({
      ...this.state,
      isFilterRemove: true,
      removeFilterId: id,
      filterType: filter_type,
    });
  };

  closeRemoveModal = () => {
    this.setState({ ...this.state, isFilterRemove: false });
  };
  validateFilter = () => {
    if (this.customFilterName.current.value.trim() === "") {
      this.setState({
        ...this.state,
        modalFilterNameError: "Please enter the filter name",
      });
      return false;
    } else if (this.customFilterName.current.value.length > 100) {
      this.setState({
        ...this.state,
        modalFilterNameError: "Maximum letter length for a name is 100.",
      });
      return false;
    } else {
      this.setState({
        ...this.state,
        modalFilterNameError: "",
      });
      return true;
    }
  };

  getTodoViewCanvas = (params) => {
    this.setState(
      (state) => {
        return {
          ...state,
          todoAttr: [],
          showReviewCanvas: true,
          singleTodoParams: params,
          isLoading: true,
        };
      },
      async () => {
        if (this.props.todoData?.todoData.length > 0) {
          this.setState((state) => {
            return {
              ...state,
              todoAttr: this.props.todoData?.todoData,
              isLoading: false,
            };
          });
          return;
        }
        let attributesParams = {
          app_token: this.state.boarddata.app_token,
          attribute_set_key: this.props.match.params.attribute_set_key,
          attribute_status: true,
          show_on_form: true,
        };
        this.setState((state) => {
          return {
            ...state,
            isLoading: true,
          };
        });
        const response = await fetch(`${this.state.apiUrl}tattle/attributes`, {
          method: "POST",
          body: JSON.stringify(attributesParams),
        });
        const rdata = await response.json();

        if (rdata.code == 200) {
          this.setState(
            (state) => {
              return {
                ...state,
                todoAttr: rdata.data,
                isLoading: false,
              };
            },
            () => {
              this.props.todoHandler(rdata.data);
            },
          );
        }
      },
    );
  };
  editFormSubmitHandler = async (values, id) => {
    this.setState((state) => {
      return {
        ...state,
        isAdding: true,
      };
    });
    let valuesforupdate = {
      ...values,
      app_token: this.state.boarddata.app_token,
      attribute_set_key: this.props.match.params.attribute_set_key,
      user_uuid: this.state.boarddata.user_uuid,
      product_key: process.env.REACT_APP_PRODUCT_KEY,
      attribute_set_name: this.state.boarddata.attribute_set_name,
      customer_tattle_uuid: +id,
    };
    const resp = await fetch(`${this.state.apiUrl}tattle/update`, {
      method: "post",
      body: JSON.stringify(valuesforupdate),
    });

    const rdata = await resp.json();
    const { code, data, status, message } = rdata;
    if (code === 200) {
      this.setState((state) => {
        return {
          ...state,
          isAdding: false,
          showReviewCanvas: false,
          // createBoard: {
          //   ...state.createBoard,
          //   message: message,
          //   title: status,
          //   bg: "primary",
          // },
        };
      });
      this.onGridReady(this.getgridapi.current);
      // onGridReady(state.gridApi, attrKey.current || state.key);
    }
  };
  getReviewTodoHandler = (columns, params) => {
    if (this.state.isLoading) {
      return <Loading />;
    }
    const fields = [];
    this.state.todoAttr.length > 0 &&
      this.state.todoAttr.forEach((item) => {
        let validation = {};
        if (item.is_required && item.attribute_type === "tel") {
          const phoneRegExp =
            /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
          validation = {
            required: string()
              .required(
                commonData.firstUpper(item.headerName + " is required "),
              )
              .matches(phoneRegExp, "Phone number is not valid")
              .max(10, "10 number is allowed"),
          };
        } else if (item.is_required && item.attribute_type === "text") {
          validation = {
            required: string()
              .trim()
              .required(
                commonData.firstUpper(item.headerName + " is required "),
              ),
          };
        } else if (item.is_required && item.attribute_type === "textarea") {
          validation = {
            required: string()
              .trim()
              .required(
                commonData.firstUpper(item.headerName + " is required "),
              ),
          };
        } else if (item.is_required && item.attribute_type === "select") {
          validation = {
            required: item.is_multiple
              ? array()
                  .min(1)
                  .required(
                    commonData.firstUpper(item.headerName + " is required "),
                  )
              : string()
                  .required(
                    commonData.firstUpper(item.headerName + " is required "),
                  )
                  .transform((value) => {
                    return value && !Array.isArray(value) ? value : value[0];
                  }),
          };
        } else if (item.is_required && item.attribute_type === "priority") {
          validation = {
            required: item.is_multiple
              ? array()
                  .min(1)
                  .required(
                    commonData.firstUpper(item.headerName + " is required "),
                  )
              : string().required(
                  commonData.firstUpper(item.headerName + " is required "),
                ),
          };
        } else if (item.is_required && item.attribute_type === "checkbox") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required "),
            ),
          };
        } else if (item.attribute_type === "number") {
          if (item.is_required) {
            validation = {
              required: number()
                .required(
                  commonData.firstUpper(item.headerName + " is required "),
                )
                .min(0),
            };
          } else {
            validation = {
              required: number()
                .min(
                  0,
                  commonData.firstUpper(
                    item.headerName + " must be equal or greater than 0",
                  ),
                )
                .nullable(true)
                .transform((_, val) => (val ? Number(val) : null)),
            };
          }
        } else if (item.is_required && item.attribute_type === "radio") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required "),
            ),
          };
        } else if (item.is_required && item.attribute_type === "date") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required "),
            ),
          };
        } else if (item.is_required && item.attribute_type === "start_date") {
          validation = {
            required: date().required(item.headerName + " is required"),
          };
        } else if (item.attribute_type === "start_date") {
          validation = {
            required: date()
              .nullable()
              .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
          };
        } else if (item.is_required && item.attribute_type === "end_date") {
          validation = {
            required: date().required(item.headerName + " is required"),
          };
        } else if (item.attribute_type === "end_date") {
          validation = {
            required: date()
              .typeError(item.headerName + " is required")
              .nullable()
              .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
          };
        } else if (item.is_required && item.attribute_type === "api") {
          if (item.is_multiple) {
            validation = {
              required: array().required(
                commonData.firstUpper(item.headerName + " is required "),
              ),
            };
          } else {
            validation = {
              required: string().required(
                commonData.firstUpper(item.headerName + " is required "),
              ),
            };
          }
        } else if (item.is_required && item.attribute_type === "assign_to") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required "),
            ),
          };
        } else if (item.is_required && item.attribute_type === "customer") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required "),
            ),
          };
        } else if (item.is_required && item.attribute_type === "assign_to") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required "),
            ),
          };
        } else if (item.is_required && item.attribute_type === "status") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required "),
            ),
          };
        } else if (item.is_required && item.attribute_type === "board") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required "),
            ),
          };
        } else if (item.attribute_type === "email") {
          validation = {
            required: string().email("Invalid Email"),
          };
        }
        fields.push({
          name: item.field,
          initialValue: "",
          type: item.attribute_type,
          ...validation,
        });
      });
    const initialValues = Object.fromEntries(
      fields.map((fiel) => [
        fiel.name,
        fiel.initialValue || params.data?.[fiel.name],
      ]),
    );

    const validObject = Object.fromEntries(
      fields.map((fiel) => [fiel.name, fiel.required]),
    );
    const userSchema = object().shape(validObject);
    const customStyles = {
      menuList: (style, state) => {
        const height = state.selectProps.inputValue
          ? "auto"
          : state.options.length > 5
            ? "180px"
            : "auto";
        return {
          ...style,
          overflowY: "auto",
          height: height,
        };
      },
    };

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={userSchema}
        onSubmit={(values, { resetForm }) => {
          this.editFormSubmitHandler(values, params.data.customer_tattle_uuid);
        }}
      >
        {(formik) => {
          return (
            <NewForm>
              {this.state.todoAttr.length > 0 &&
                this.state.todoAttr.map((item, index) => {
                  if (item.attribute_type === "text") {
                    <span>adads</span>;
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name={item.field}
                            value={formik.values[item.field]}
                            onChange={(evt) =>
                              formik.setFieldValue(item.field, evt.target.value)
                            }
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            autoComplete="off"
                          />
                          {item?.min_length &&
                            formik.values[item.field] &&
                            formik.touched[item.field] &&
                            formik.values[item.field]
                              .replace(/<[^>]+>/g, "")
                              .trim().length < Number(item.min_length) && (
                              <p className="input-warning">
                                <i className="fas fa-exclamation-triangle"></i>
                                The recommended {item.headerName.toLowerCase()}{" "}
                                length is at least {item.min_length} characters.
                              </p>
                            )}
                        </div>

                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (
                    item.attribute_type === "checkbox" &&
                    item.field == "completed"
                  ) {
                    return "";
                    // return (
                    //   <Row className="mb-2" key={index}>
                    //     <div className="form-group">
                    //       <label
                    //         className={
                    //           "col-12 " +
                    //           (item.is_required ? "form-label _required" : "")
                    //         }
                    //       >
                    //         {item.headerName}
                    //       </label>
                    //       <input type="checkbox" />
                    //     </div>
                    //   </Row>
                    // );
                  }
                  if (item.attribute_type === "api") {
                    // const options = Object.keys(item.options).map((ite) => ({
                    //   label: item.options[ite].name,
                    //   value: item.options[ite].user_uuid,
                    //   profile: item.options[ite].profile_image,
                    // }));

                    const valassi = state.defaultAsyncValue[item.field]?.filter(
                      (nt) => nt.value == formik.values[item.field],
                    );
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>

                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            value={valassi}
                            onChange={(value) => {
                              formik.setFieldValue(
                                item.field,
                                !value ? "" : value.value,
                              );
                            }}
                            isClearable
                            loadOptions={(evt) => {
                              return getOptionsForAsync(
                                item.api_url,
                                evt,
                                item.field,
                              );
                            }}
                            styles={customStyles}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "customer") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            onChange={(value) => {
                              formik.setFieldValue(item.field, value.value);
                            }}
                            loadOptions={(evt) => {
                              return getOptionsForAsync(item.api_url, evt);
                            }}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "er") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            onChange={(value) => {
                              formik.setFieldValue(item.field, value.value);
                            }}
                            styles={customStyles}
                            loadOptions={(evt) => {
                              return getOptionsForAsync(item.api_url, evt);
                            }}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }

                  if (item.attribute_type === "assign_to") {
                    const { Option } = components;

                    const valassi = this.state.activeUsers.filter(
                      (nt) => nt.value == formik.values[item.field],
                    );
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            maxMenuHeight={175}
                            loadOptions={(evt) =>
                              this.getPeoplesCall(evt, item.api_url)
                            }
                            menuPlacement="auto"
                            isMulti={item.is_multiple}
                            components={{ Option: CustomOption }}
                            name="label"
                            // isClearable={true}
                            ref={this.assignToSelect}
                            value={valassi}
                            placeholder={this.firstUpper(item.headerName)}
                            onChange={(value) =>
                              formik.setFieldValue(
                                item.field,
                                !value ? "" : value.value,
                              )
                            }
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "select") {
                    const options =
                      item.options &&
                      item.options.map((sel) => ({
                        label: sel.option_name,
                        value: sel.id || sel._id,
                      }));

                    let vall = options.find(
                      (nio) => nio.value == formik.values[item.field],
                    );

                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>

                          <ReactSelect
                            onChange={(value) => {
                              formik.setFieldValue(
                                item.field,
                                !value ? "" : value.value,
                              );
                            }}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            menuPlacement="auto"
                            // isClearable
                            value={vall}
                            styles={customStyles}
                            options={options}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "priority") {
                    const options =
                      item.options &&
                      item.options.map((sel) => ({
                        label: sel.option_name,
                        value: sel.id || sel._id,
                      }));

                    let vall = options.filter(
                      (nio) => nio.value == formik.values[item.field],
                    );
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactSelect
                            onChange={(value) => {
                              formik.setFieldValue(
                                item.field,
                                !value ? "" : value.value,
                              );
                            }}
                            menuPlacement="auto"
                            // isClearable
                            value={vall}
                            styles={customStyles}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            options={options}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "status") {
                    const options = item.options.map((ite) => ({
                      label: ite.name,
                      value: ite.id || ite._id,
                    }));

                    let values = options.find(
                      (ite) => ite.value == formik.values[item.field],
                    );
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>

                          <ReactSelect
                            value={values}
                            isMulti={false}
                            onChange={(value) => {
                              formik.setFieldValue(item.field, value.value);
                            }}
                            menuPlacement="auto"
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            options={options}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "email") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <input
                            value={formik.values[item.field]}
                            type={"email"}
                            className="form-control"
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "textarea") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <DraftjsInline
                            key={index}
                            editorState={formik.values[item.field] || ""}
                            field={item.field}
                            formik={formik}
                            onChange={(newEditorState) => {
                              formik.setFieldValue(item.field, newEditorState);
                            }}
                            onBlur={() => {
                              formik.setFieldTouched(item.field, true);
                            }}
                          />
                          {item?.min_length &&
                            formik.touched[item.field] &&
                            formik.values[item.field] &&
                            formik.values[item.field]
                              .replace(/<[^>]+>/g, "")
                              .trim().length < Number(item.min_length) && (
                              <p className="description-warning">
                                <i className="fas fa-exclamation-triangle"></i>
                                The recommended {item.headerName.toLowerCase()}{" "}
                                length is at least {item.min_length} characters.
                              </p>
                            )}
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "date") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactDatePicker
                            className="rasta-stripes"
                            dateFormat="dd-MM-yyyy"
                            selected={
                              formik.values[item.field]
                                ? new Date(formik.values[item.field])
                                : null
                            }
                            placeholderText="dd-mm-yyyy"
                            onChange={(evt) => {
                              this.reactDatePickerHandler(
                                evt,
                                formik,
                                item.field,
                              );
                            }}
                          />
                          {/* <input
                            value={formik.values[item.field]}
                            type={"date"}
                            className="form-control"
                            onChange={(evt) =>
                              formik.setFieldValue(item.field, evt.target.value)
                            }
                            // min={new Date().toISOString().split("T")[0]}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                          /> */}
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "start_date") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactDatePicker
                            className="rasta-stripes"
                            selected={
                              formik.values[item.field]
                                ? new Date(formik.values[item.field])
                                : null
                            }
                            minDate={
                              formik.values[item.field]
                                ? new Date(formik.values[item.field]).setDate(
                                    new Date(
                                      formik.values[item.field],
                                    ).getDate() - 30,
                                  )
                                : new Date().setDate(new Date().getDate() - 30)
                            }
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            isClearable
                            onChange={(evt) => {
                              let date = convertDateFormat(evt);
                              if (
                                formik.values["end_date"] &&
                                date > formik.values["end_date"]
                              ) {
                                setState((state) => {
                                  return {
                                    ...state,
                                    createBoard: {
                                      ...state.createBoard,
                                      board: true,
                                      bg: "danger",
                                      title: "error",
                                      message:
                                        "Start date shouldn't greater than End date",
                                    },
                                  };
                                });
                                return;
                              }
                              formik.setFieldValue(item.field, date);
                            }}
                            placeholderText="dd-mm-yyyy"
                            dateFormat={"dd-MM-yyyy"}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "end_date") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactDatePicker
                            className="rasta-stripes"
                            selected={
                              formik.values[item.field]
                                ? new Date(formik.values[item.field])
                                : null
                            }
                            isClearable
                            onChange={(evt) => {
                              let date = convertDateFormat(evt);
                              formik.setFieldValue(item.field, date);
                            }}
                            minDate={
                              formik.values["start_date"]
                                ? new Date(formik.values["start_date"])
                                : new Date().setDate(new Date().getDate() - 30)
                            }
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            placeholderText="dd-mm-yyyy"
                            dateFormat={"dd-MM-yyyy"}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {" "}
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "go_live_date") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactDatePicker
                            className="rasta-stripes"
                            selected={
                              formik.values[item.field]
                                ? new Date(formik.values[item.field])
                                : null
                            }
                            isClearable
                            onChange={(evt) =>
                              formik.setFieldValue(
                                item.field,
                                convertDateFormat(evt),
                              )
                            }
                            minDate={
                              formik.values["end_date"]
                                ? new Date(formik.values["end_date"])
                                : new Date().setDate(new Date().getDate() - 30)
                            }
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            placeholderText="dd-mm-yyyy"
                            dateFormat={"dd-MM-yyyy"}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {" "}
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }

                  if (item.attribute_type === "attachment") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <div
                            className="file-upload"
                            disabled={state.isImageUpload && "disabled"}
                          >
                            <button
                              type="button"
                              className="file-name"
                              htmlFor="custom-attachment"
                              onClick={showModalPopupHandler}
                            >
                              <i
                                className="fa fa-plus hidden-sm"
                                aria-hidden="true"
                              ></i>
                              &nbsp;
                              <span>
                                {state.isImageUpload
                                  ? "Uploading..."
                                  : "Choose Files"}
                              </span>
                            </button>
                            <div className="file-selected"></div>
                          </div>
                          <input
                            type="file"
                            className="form-control"
                            autoComplete={"off"}
                            onChange={onFileChangeHandler}
                            id="custom-attachment"
                            multiple={true}
                            style={{ display: "none" }}
                          />
                        </div>
                        <div className="custom_image">
                          <div className="afterupload-image mt-2 newupload">
                            {Object.keys(state.saveImageFile).length > 0 &&
                              Object.keys(state.saveImageFile).map((item) => {
                                return (
                                  <div className="uploadimages">
                                    <ImagePreview
                                      headImage={state.saveImageFile[item]}
                                      className="newchild_upload"
                                      width="165px"
                                      gap="5px"
                                      height="80px"
                                    />
                                    <div
                                      className="delete"
                                      onClick={() => removeUploadImage(item)}
                                    >
                                      <svg
                                        width="11"
                                        height="10"
                                        viewBox="0 0 11 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{
                                          marginLeft: "-1px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <path
                                          d="M8.21973 2.5L3.21973 7.5"
                                          stroke="#737373"
                                          stroke-width="1.33"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></path>
                                        <path
                                          d="M3.21973 2.5L8.21973 7.5"
                                          stroke="#737373"
                                          stroke-width="1.33"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></path>
                                        <title>Remove</title>
                                      </svg>
                                    </div>
                                  </div>
                                );
                              })}
                            {Object.keys(state.editForm?.attachment || {})
                              .length > 0 &&
                              Object.keys(state.editForm.attachment).map(
                                (item) => {
                                  return (
                                    <div className="uploadimages">
                                      <ImagePreview
                                        headImage={
                                          state.editForm.attachment[item]
                                        }
                                        className="newchild_upload"
                                        width="165px"
                                        gap="5px"
                                        height="90px"
                                      />
                                      <div
                                        className="delete"
                                        onClick={() =>
                                          removeEditUploadImage(item)
                                        }
                                      >
                                        <svg
                                          width="11"
                                          height="10"
                                          viewBox="0 0 11 10"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          style={{
                                            marginLeft: "-1px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <path
                                            d="M8.21973 2.5L3.21973 7.5"
                                            stroke="#737373"
                                            stroke-width="1.33"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <path
                                            d="M3.21973 2.5L8.21973 7.5"
                                            stroke="#737373"
                                            stroke-width="1.33"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <title>Remove</title>
                                        </svg>
                                      </div>
                                    </div>
                                  );
                                },
                              )}
                          </div>
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "checkbox") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <input
                            value={formik.values[item.field]}
                            type={"checkbox"}
                            className="form-control"
                            onChange={(evt) =>
                              formik.setFieldValue(item.field, evt.target.value)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "reporter") {
                    const { Option } = components;

                    const valassi = this.state.activeUsers.filter(
                      (nt) => nt.value == formik.values[item.field],
                    );
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            Assigned By
                          </label>
                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            maxMenuHeight={175}
                            loadOptions={(evt) =>
                              this.getPeoplesCall(evt, item.api_url)
                            }
                            menuPlacement="auto"
                            isMulti={item.is_multiple}
                            components={{ Option: CustomOption }}
                            name="label"
                            // isClearable={true}
                            ref={this.assignToSelect}
                            value={valassi}
                            placeholder={this.firstUpper(item.headerName)}
                            onChange={(value) =>
                              formik.setFieldValue(
                                item.field,
                                !value ? "" : value.value,
                              )
                            }
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                })}
              <div className="form-group mt-3">
                <Button
                  type="submit"
                  text="Save"
                  className="btn muBtn _blue"
                  // isDisabled={state.isImageUpload}
                  isAdding={this.state.isAdding}
                />
              </div>
            </NewForm>
          );
        }}
      </Formik>
    );
  };

  createCustomFilterHandler = async (evt) => {
    evt.preventDefault();
    const filtersData = {
      app_token: this.state.boarddata.app_token,
      filter_id: Date.now(),
      attribute_set_key: this.props.match.params.attribute_set_key,
      user_uuid: this.state.boarddata.user_uuid,
      filter_name: this.customFilterName.current.value,
      filter_value: this.state.filterType
        ? this.state.advance_filter
        : { ...this.state.filterMod },
      is_system: 0,
      filter_type: this.state.filterType,
    };
    let objKeys = Object.keys(filtersData.filter_value);
    objKeys = objKeys.flatMap((item) => {
      if (item === "customer_name") {
        return "name";
      } else if (item === "range") {
        return Object.keys(filtersData?.filter_value[item] ?? {});
      } else {
        return item;
      }
    });
    if (this.validateFilter()) {
      this.setState(
        {
          ...this.state,
          isFilterCreate: false,
          filterpopup: false,
          selectColumnsCheck: objKeys,
          modalFilterNameError: "",
          enebleAdvancedClickFilter: false,
          filterName: this.customFilterName.current.value,
        },
        async () => {
          this.storeFilterInLocal({
            ...this.state.filterMod,
            selected_filter: filtersData.filter_id,
          });
          let saved_filterId = await this.props.createCustomFilter(filtersData);
          if (saved_filterId.code == 200) {
            const getselectedFilter = localStorage.getItem("selected_filter");
            if (getselectedFilter && this.IsJsonString(getselectedFilter)) {
              const parsejson = JSON.parse(getselectedFilter);
              let selectedFiltrObj = {
                ...parsejson,
                [this.props.match.params.attribute_set_key]:
                  saved_filterId.data.filter_id,
              };
              localStorage.setItem(
                "selected_filter",
                JSON.stringify(selectedFiltrObj),
              );
            } else {
              let selectedFiltrObj = {
                [this.props.match.params.attribute_set_key]:
                  saved_filterId.data.filter_id,
              };
              localStorage.setItem(
                "selected_filter",
                JSON.stringify(selectedFiltrObj),
              );
            }
          }
          //          this.props.createCustomFilter(filtersData);
          this.onGridReady(this.getgridapi.current);
        },
      );
    }
  };
  getTodoBoardD = async () => {
    const { todoData } = this.props.todoData;
    if (
      todoData &&
      todoData.length > 0 &&
      this.state.boarddata?.attribute_set_type ===
        this.props?.filter?.attribute_set_type
    ) {
      this.setState((state) => {
        return {
          ...state,
          todoAttr: todoData,
          isLoading: false,
        };
      });
    } else {
      let attributesParams = {
        app_token: this.state.boarddata.app_token,
        attribute_set_key: this.props.match.params.attribute_set_key,
        attribute_status: true,
        show_on_form: true,
      };
      this.setState((state) => {
        return {
          ...state,
          isLoading: true,
        };
      });
      const response = await fetch(`${this.state.apiUrl}tattle/attributes`, {
        method: "POST",
        body: JSON.stringify(attributesParams),
      });
      const rdata = await response.json();

      if (rdata.code == 200) {
        this.setState(
          (state) => {
            return {
              ...state,
              todoAttr: rdata.data,
              isLoading: false,
            };
          },
          () => {
            this.props.todoHandler(this.state.todoAttr);
          },
        );
      }
    }
  };

  showAddTodoCanvas = () => {
    this.setState(
      (state) => {
        return {
          ...state,
          showtodocanvas: true,
          getPeopleApiCall: false,
          showAllattribute: false,
          createBoard: {
            ...state.createBoard,
            board: false,
          },
        };
      },
      () => {},
    );
    this.getTodoBoardD();
  };
  canvasCloseHandler = () => {
    this.setState((state) => {
      return {
        ...state,
        showtodocanvas: false,
        showReviewCanvas: false,
        showTodoNote: false,
      };
    });
  };
  formSubmitHandler = async (values) => {
    this.setState((state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    values = {
      ...values,
      ...this.defaultUserLogin.current,
      ...(this.state.boarddata.attribute_set_type == 4 &&
        values?.completed == "" && {
          completed: "false",
        }),
    };
    let listing_form_submit = {
      ...values,
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.attribute_set_key,
      attribute_set_type: this.state.boarddata.attribute_set_type,
    };
    const response = await fetch(`${this.state.apiUrl}tattle/create`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(listing_form_submit),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      setTimeout(() => {
        this.setState(
          {
            ...this.state,
            showtodocanvas: false,
            isSubmitting: false,
            agGridStateUpdate: false,
            // createBoard: {
            //   ...this.state.createBoard,
            //   board: true,
            //   formdata: {},
            //   message: rdata.message,
            //   title: rdata.status,
            //   bg: "primary",
            // },
            attachImages: null,
            isSaving: false,
          },
          () => {
            this.onGridReady(this.getgridapi.current);
          },
        );
      });
    }
  };

  defaultCheck = (field, value) => {
    this.defaultUserLogin.current = {
      ...this.defaultUserLogin.current,
      [field]: value,
    };
  };

  convertToReactSelect = (data) => {
    let newdata = null;
    if (Array.isArray(data)) {
      newdata = data.map((item) => ({ label: item.value, value: item.id }));
    } else {
    }
    return newdata;
  };

  fetchData = async (api_url, evt, field) => {
    if (
      evt &&
      this.state.todoBoardData[field] &&
      this.state.todoBoardData[field].length > 0
    ) {
      return this.state.todoBoardData[field].filter((item) =>
        item.label.toLowerCase().includes(evt.toLowerCase()),
      );
    }
    const response = await fetch(api_url);
    const rdata = await response.json();
    let newConvertData = this.convertToReactSelect(rdata);
    this.setState(
      (state) => {
        return {
          ...state,
          todoBoardData: {
            ...this.state.todoBoardData,
            [field]: newConvertData,
          },
        };
      },
      () => {},
    );
    return newConvertData;
  };

  getHiddenFormFieldValue = (formik, item, index) => {
    if (item.attribute_type === "text") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => {
                this.clearform = el;
                this.focusRef.current = el;
              }}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`input-cls form-control ${
                item.is_required && "required"
              }`}
              autocomplete={"off"}
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
            {item?.min_length &&
              formik.values[item.field] &&
              formik.touched[item.field] &&
              formik.values[item.field].replace(/<[^>]+>/g, "").trim().length <
                Number(item.min_length) && (
                <p className="input-warning">
                  <i className="fas fa-exclamation-triangle"></i>
                  The recommended {item.headerName.toLowerCase()} length is at
                  least {item.min_length} characters.
                </p>
              )}
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }

    if (item.attribute_type === "email") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (this.clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`form-control mb-3 ${item.is_required && "required"}`}
              autoComplete={"off"}
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "company_name") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (this.clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`form-control mb-3 ${item.is_required && "required"}`}
              autoComplete={"off"}
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "customer_type") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (this.clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`form-control mb-3 ${item.is_required && "required"}`}
              autoComplete={"off"}
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "cc") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (this.clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`form-control mb-3 ${item.is_required && "required"}`}
              autoComplete={"off"}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "monitoring") {
      let values = [];
      if (formik.values) {
        values = this.state.activeUsers.filter(
          (it) => it.value && formik.values[item.field].includes(it.value),
        );
      }
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              maxMenuHeight={175}
              menuPlacement="auto"
              isMulti={true}
              components={{ Option: CustomOption }}
              name="label"
              placeholder={this.firstUpper(item.headerName)}
              value={values}
              // isClearable={true}
              loadOptions={(evt) => this.getPeoplesCall(evt, item.api_url)}
              onChange={(value) => {
                formik.setFieldValue(
                  item.field,
                  !value
                    ? ""
                    : Array.isArray(value)
                      ? value.map((item) => item.value)
                      : value.value,
                );
              }}
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "age") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (this.clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`form-control mb-3 ${item.is_required && "required"}`}
              autoComplete={"off"}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "checkbox") {
      return "";
    }

    if (item.headerName !== undefined && item.attribute_type === "textarea") {
      return (
        <Col md={12} className="mb-3 ck_editing">
          <div className="inputbox-group mb-3">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>

            <DraftjsInline
              key={index}
              editorState={formik.values[item.field] || ""}
              field={item.field}
              formik={formik}
              onChange={(newEditorState) => {
                formik.setFieldValue(item.field, newEditorState);
              }}
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
            {item?.min_length &&
              formik.values[item.field] &&
              formik.touched[item.field] &&
              formik.values[item.field].replace(/<[^>]+>/g, "").trim().length <
                Number(item.min_length) && (
                <p className="input-warning">
                  <i className="fas fa-exclamation-triangle"></i>
                  The recommended {item.headerName.toLowerCase()} length is at
                  least {item.min_length} characters.
                </p>
              )}

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "radio") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group form_checkbox_validation">
            {item.options.map((it, index) => {
              return (
                <>
                  <input
                    type={item.attribute_type}
                    ref={(el) => (this.clearform = el)}
                    placeholder={`${item.headerName}`}
                    name={item.field}
                    onChange={formik.handleChange}
                    value={formik.values[item.field]}
                    className={`input-cls ${item.is_required && "required"}`}
                    autocomplete={"off"}
                    onBlur={(evt) => formik.setFieldTouched(item.field, true)}
                  />{" "}
                  <label>{this.firstUpper(it.option_name)}</label>
                </>
              );
            })}
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "tel") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (this.clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`input-cls ${item.is_required && "required"}`}
              autocomplete={"off"}
              onBlur={(evt) => formik.setFieldTouched(item.field, true)}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "number") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (this.clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              min={0}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`input-cls ${item.is_required && "required"}`}
              autocomplete={"off"}
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "date") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group date">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <ReactDatePicker
              className="rasta-stripes"
              dateFormat="dd-MM-yyyy"
              selected={
                formik.values[item.field]
                  ? new Date(formik.values[item.field])
                  : null
              }
              placeholderText="dd-mm-yyyy"
              onChange={(evt) => {
                this.reactDatePickerHandler(evt, formik, item.field);
              }}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "start_date") {
      const currentDate = new Date();
      const pastDate = formik.values[item.field]
        ? new Date(formik.values[item.field])
        : currentDate.setDate(currentDate.getDate() - 30);
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group date">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>

            <ReactDatePicker
              className="rasta-stripes"
              dateFormat="dd-MM-yyyy"
              selected={
                formik.values[item.field]
                  ? new Date(formik.values[item.field])
                  : null
              }
              minDate={pastDate}
              placeholderText="dd-mm-yyyy"
              onChange={(evt) =>
                this.reactDatePickerHandler(evt, formik, item.field)
              }
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "end_date") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group date">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>

            <ReactDatePicker
              className="rasta-stripes"
              dateFormat="dd-MM-yyyy"
              selected={
                formik.values[item.field]
                  ? new Date(formik.values[item.field])
                  : null
              }
              minDate={
                formik.values["start_date"]
                  ? new Date(formik.values["start_date"])
                  : new Date()
              }
              placeholderText="dd-mm-yyyy"
              onChange={(evt) =>
                this.reactDatePickerHandler(evt, formik, item.field)
              }
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "go_live_date") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group date">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>

            <ReactDatePicker
              className="rasta-stripes"
              dateFormat="dd-MM-yyyy"
              selected={formik.values[item.field]}
              minDate={
                formik.values["end_date"] ||
                new Date().setDate(new Date().getDate())
              }
              placeholderText="dd-mm-yyyy"
              onChange={(evt) =>
                this.reactDatePickerHandler(evt, formik, item.field)
              }
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "board") {
      return (
        <Col md={12}>
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >
              {this.firstUpper(item.headerName)}
            </label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={(evt) =>
                this.loadAddress(item.api_url, evt, "child_board")
              }
              onChange={(value) => {
                formik.setFieldValue(item.field, value.value);
              }}
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "api") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <>
              <AsyncSelect
                placeholder={item.headerName}
                isMulti={item.is_multiple}
                cacheOptions
                ref={(el) => (this.clearFormSelect[index] = el)}
                value={this.state.apiOptions.find(
                  (ite) => ite.value == formik.values[item.field],
                )}
                defaultOptions
                isClearable={true}
                loadOptions={(evt) =>
                  this?.fetchData(item.api_url, evt, item.field)
                }
                onBlur={() => formik.setFieldTouched(item.field, true)}
                maxMenuHeight={175}
                onChange={(value) => {
                  formik.setFieldValue(
                    item.field,
                    !value
                      ? ""
                      : Array.isArray(value)
                        ? value.map((item) => item.value)
                        : value.value,
                  );
                }}
              />
            </>

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "project") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <>
              <AsyncSelect
                placeholder={item.headerName}
                isMulti={true}
                ref={(el) => (this.clearFormSelect[index] = el)}
                cacheOptions
                defaultOptions
                loadOptions={(evt) => this.loadAddress(item.api_url, evt, "er")}
                maxMenuHeight={175}
                onChange={(value) => {
                  formik.setFieldValue(
                    item.field,
                    Array.isArray(value)
                      ? value.map((item) => item.value)
                      : value.value,
                  );
                }}
                onBlur={() => formik.setFieldTouched(item.field, true)}
              />
            </>

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "select") {
      const options = item.options.map((item) => ({
        ...item,
        label: item.option_name,
        value: item.id || item._id,
      }));
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <Field
              placeholder={item.headerName}
              isMulti={item.is_multiple}
              options={options}
              key={index}
              refs={(el) => (this.clearFormSelect[index] = el)}
              onBlur={() => formik.setFieldTouched(item.field, true)}
              maxMenuHeight={175}
              name={item.field}
              component={ReactCustomSelect}
              formik={formik}
            />
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "priority") {
      const options = item.options.map((item) => ({
        ...item,
        label: item.option_name,
        value: item.id || item._id,
      }));

      let value;
      if (
        item.hasOwnProperty("defaultvalue") &&
        item.defaultvalue &&
        !formik.values[item.field]
      ) {
        value = options.filter((it) => it.value == item.defaultvalue);
        this.defaultCheck(item.field, value[0].value);
        formik.setFieldValue(item.field, value[0].value);
      } else {
        value = options.filter((it) => it.value == formik.values[item.field]);
        this.defaultCheck(item.field, formik.values[item.field]);
      }

      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <ReactSelect
              placeholder={item.headerName}
              options={options}
              value={value}
              key={index}
              onBlur={() => formik.setFieldTouched(item.field, true)}
              isMulti={item.is_multiple}
              maxMenuHeight={175}
              onChange={(evt) => {
                formik.setFieldValue(
                  item.field,
                  item.is_multiple
                    ? options.map((item) => item.value)
                    : !evt
                      ? ""
                      : evt.value,
                );
              }}
            />
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "category") {
      const options = item.options;
      const newoptions = options.map((item) => ({
        label: item.name,
        value: item.id || item._id,
      }));
      const values = newoptions.filter(
        (it) => it.value === formik.values[item.field],
      );
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <ReactSelect
              // isMulti={item.is_multiple}
              options={newoptions || []}
              maxMenuHeight={175}
              ref={(el) => (this.clearFormSelect[index] = el)}
              value={values}
              name="label"
              placeholder={this.firstUpper(item.headerName)}
              onChange={(value) =>
                formik.setFieldValue(item.field, value.value)
              }
            />
          </div>
          <Bform.Control.Feedback
            type="invalid"
            style={
              formik.errors[item.field] && formik.touched[item.field]
                ? {
                    display: "block",
                  }
                : {}
            }
          >
            {formik.errors[item.field] && formik.touched[item.field] ? (
              <div class="error">{formik.errors[item.field]}</div>
            ) : null}
          </Bform.Control.Feedback>
        </Col>
      );
    }
    if (item.attribute_type === "assign_to") {
      const { options } = item;
      // const userDetails = commondata.IsJsonString(
      //   this.state.boarddata.user_details
      // )
      //   ? JSON.parse(this.state.boarddata.user_details)
      //   : "";

      //check todo

      const { SingleValue, Option } = components;

      let value;
      if (
        item.hasOwnProperty("defaultvalue") &&
        item.defaultvalue &&
        !formik.values[item.field]
      ) {
        value = this.state.activeUsers.filter(
          (it) => it.value == commonData.getCommonData().user_uuid,
        );
        this.defaultCheck(item.field, commonData.getCommonData().user_uuid);
        formik.setFieldValue(item.field, commonData.getCommonData().user_uuid);
      } else {
        if (formik.values[item.field]) {
          value = this.state.activeUsers.filter(
            (it) => it.value == formik.values[item.field],
          );
        }

        this.defaultCheck(item.field, formik.values[item.field]);
      }

      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              maxMenuHeight={175}
              loadOptions={(evt) => this.getPeoplesCall(evt, item.api_url)}
              menuPlacement="auto"
              isMulti={item.is_multiple}
              components={{ Option: CustomOption }}
              name="label"
              isClearable={true}
              ref={this.assignToSelect}
              value={value}
              placeholder={this.firstUpper(item.headerName)}
              onChange={(value) =>
                formik.setFieldValue(item.field, !value ? "" : value.value)
              }
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
          </div>
          <Bform.Control.Feedback
            type="invalid"
            style={
              formik.errors[item.field] && formik.touched[item.field]
                ? {
                    display: "block",
                  }
                : {}
            }
          >
            {formik.errors[item.field] && formik.touched[item.field] ? (
              <div class="error">{formik.errors[item.field]}</div>
            ) : null}
          </Bform.Control.Feedback>
        </Col>
      );
    }
    if (item.attribute_type === "status") {
      const newoptions =
        item?.options &&
        item.options.map((item) => ({
          label: item.name,
          value: item.id || item._id,
        }));
      const statusVal = newoptions.filter(
        (it) => it.value === formik.values[item.field],
      );
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <ReactSelect
              // isMulti={item.is_multiple}
              options={newoptions || []}
              maxMenuHeight={175}
              ref={(el) => (this.clearFormSelect[index] = el)}
              value={statusVal}
              name="label"
              placeholder={this.firstUpper(item.headerName)}
              onChange={(value) =>
                formik.setFieldValue(item.field, value.value)
              }
            />
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "reporter") {
      const { SingleValue, Option } = components;

      const IconOption = (props) => {
        const getimage = props.options.find(
          (item) => item.value === props.value,
        ).profile;
        return (
          <Option {...props}>
            <img
              style={{ width: "20px" }}
              src={`${
                getimage ||
                "data:image/png;base64,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"
              }`}
            />{" "}
            &nbsp;
            {props.data.label}
          </Option>
        );
      };
      let newoptions = [];

      for (let ip in this.state.users) {
        newoptions.push({
          label: this.state.users[ip].name,
          value: this.state.users[ip].user_uuid,
          profile: this.state.users[ip].profile_image,
        });
      }

      let value;
      if (
        item.hasOwnProperty("defaultvalue") &&
        item.defaultvalue &&
        !formik.values[item.field]
      ) {
        value = newoptions.filter(
          (it) => it.value == commonData.getCommonData().user_uuid,
        );
        this.defaultCheck(item.field, commonData.getCommonData().user_uuid);
        formik.setFieldValue(item.field, commonData.getCommonData().user_uuid);
      } else if (formik.values[item.field]) {
        value = newoptions.filter(
          (it) => it.value == formik.values[item.field],
        );
        this.defaultCheck(item.field, formik.values[item.field]);
      } else {
        value = newoptions.filter(
          (it) => it.value == commonData.commonData().userId,
        );
        this.defaultCheck(item.field, value?.[0].value);
      }
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <ReactSelect
              isMulti={item.is_multiple}
              options={newoptions || []}
              maxMenuHeight={175}
              name="label"
              value={value}
              components={{
                Option: IconOption,
              }}
              placeholder={this.firstUpper(item.headerName)}
              onChange={(value) =>
                formik.setFieldValue(item.field, value.value)
              }
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
          </div>
        </Col>
      );
    }
    if (
      [
        "textarea",
        "tel",
        "checkbox",
        "radio",
        "select",
        "attachment",
        "text",
        "number",
        "email",
        "date",
        "api",
        "er",
      ].includes(item.attribute_type) === false
    ) {
      if (item.attribute_type === "customer") {
        return (
          <Col md={12} className="mb-3">
            <div className="inputbox-group">
              <label
                className={
                  "col-12 " + (item.is_required ? "form-label _required" : "")
                }
              >{`${this.firstUpper(item.headerName)}`}</label>
              <>
                <input
                  type={item.attribute_type}
                  ref={(el) => (this.clearform = el)}
                  placeholder={`${item.headerName}`}
                  name={item.field}
                  onChange={formik.handleChange}
                  value={formik.values[item.field]}
                  className={`input-cls ${item.is_required && "required"}`}
                  autoComplete={"off"}
                  onBlur={() => formik.setFieldTouched(item.field, true)}
                />
                {/* <AsyncSelect
                            placeholder={item.headerName}
                            cacheOptions
                            defaultOptions
                            loadOptions={(evt) =>
                              this.loadAddress(
                                item.api_url,
                                evt,
                                "customer"
                              )
                            }
                            maxMenuHeight={175}
                            onChange={(value) => {
                              formik.setFieldValue(
                                item.field,
                                Array.isArray(value)
                                  ? value.map(
                                      (item) => item.value
                                    )
                                  : value.value
                              );
                            }}
                            onBlur={() =>
                              formik.setFieldTouched(
                                item.field,
                                true
                              )
                            }
                          /> */}
              </>
              <Bform.Control.Feedback
                type="invalid"
                style={
                  formik.errors[item.field] && formik.touched[item.field]
                    ? {
                        display: "block",
                      }
                    : {}
                }
              >
                {formik.errors[item.field] && formik.touched[item.field] ? (
                  <div class="error">{formik.errors[item.field]}</div>
                ) : null}
              </Bform.Control.Feedback>
            </div>
          </Col>
        );
      }
    }
    if (item.attribute_type === "attachment") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${this.firstUpper(item.headerName)}`}</label>
            <div className="file-upload">
              <label className="file-name" htmlFor="custom-attachment">
                <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                &nbsp;
                <span>
                  {" "}
                  {Array.from(this.state.attachments).length > 0
                    ? Array.from(this.state.attachments).length +
                      " files selected"
                    : this.state.isAddPageUpload
                      ? "Uploading..."
                      : "Choose Files"}
                </span>
              </label>
              <div className="file-selected"></div>
            </div>

            <input
              type="file"
              className="form-control"
              onChange={this.uploadAttachment}
              autoComplete={"off"}
              id="custom-attachment"
              multiple={true}
              style={{ display: "none" }}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
          <div className="afterupload-image">
            {Array.from(this.state.attachments).map((item, ind) =>
              this.getBase64(item, ind),
            )}
          </div>
          <div className="custom_image">
            {this.state.attachImages &&
              Object.keys(this.state.attachImages).length > 0 && (
                <div class="afterupload-image mt-2">
                  {this.state.attachImages &&
                    Object.keys(this.state.attachImages).map((item, ii) => {
                      return this.getBlobImages(
                        this.state.attachImages[item],
                        item,
                      );
                    })}
                </div>
              )}
            <div class="clone afterupload-image mt-2">
              {Object.keys(formik.values[item.field] || {}).length > 0 &&
                Object.keys(formik.values[item.field]).map((it) => {
                  return (
                    <div class=" img-box">
                      <Error>
                        <ImagePreview
                          headImage={formik.values[item.field][it]}
                          width="150px"
                          height="80px"
                        />
                      </Error>
                      <div
                        class="delete"
                        onClick={() => this.removeCloneImages(it, formik)}
                      >
                        <svg
                          width="11"
                          height="10"
                          viewBox="0 0 11 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.21973 2.5L3.21973 7.5"
                            stroke="#737373"
                            stroke-width="1.33"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M3.21973 2.5L8.21973 7.5"
                            stroke="#737373"
                            stroke-width="1.33"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </Col>
      );
    }
    let newoptions = [];
    for (let ip in item.options) {
      newoptions.push({
        label: `${item.options[ip].name}`,
        value: item.options[ip].user_uuid || item.ip,
      });
    }
    const values = newoptions.filter(
      (ite) => ite.value === formik.values[item.field],
    );
    return (
      <Col md={12} className="mb-3">
        <div className="inputbox-group">
          <label
            className={
              "col-12 " + (item.is_required ? "form-label _required" : "")
            }
          >{`${this.firstUpper(item.headerName)}`}</label>
          <ReactSelect
            options={newoptions || []}
            isMulti={item.is_multiple}
            name="label"
            maxMenuHeight={175}
            placeholder={this.firstUpper(item.headerName)}
            ref={(el) => (this.clearFormSelect[index] = el)}
            value={values}
            onChange={(value) => {
              formik.setFieldValue(item.field, value.value);
            }}
            onBlur={() => formik.setFieldTouched(item.field, true)}
          />
          <Bform.Control.Feedback
            type="invalid"
            style={
              formik.errors[item.field] && formik.touched[item.field]
                ? {
                    display: "block",
                  }
                : {}
            }
          >
            {formik.errors[item.field] && formik.touched[item.field] ? (
              <div class="error">{formik.errors[item.field]}</div>
            ) : null}
          </Bform.Control.Feedback>
        </div>
      </Col>
    );
  };
  checkFilterLocalAndConvert = () => {
    const filtervalue = localStorage.getItem("filter");
    if (filtervalue) {
      // convert from string to object
      let convertfromstring = commonData.IsJsonString(filtervalue)
        ? JSON.parse(filtervalue)
        : "";
      if (convertfromstring) {
        return convertfromstring[this.props.match.params.attribute_set_key];
      }
    }
  };

  submitReasonData = (json, data) => {
    const { modalCallback } = this.state;

    if (!modalCallback) return;

    let val;

    if (this.state?.editData?.newValue) {
      val = this.state?.editData?.newValue;
    } else {
      val = this.state?.editData;
    }

    // Call the modalCallback and reset state after the modal action
    return modalCallback({
      status: "success",
      data,
      val,
    });
  };

  getSharedFilter = async (filterId) => {
    try {
      console.log(filterId, "filterIdfilterIdfilterId");
      const response = await fetch(
        `${process.env.REACT_APP_API}/get-custom-filter/?filter_id=${filterId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();

      if (data.code == 200) {
        return data?.data?.filter_value;
      }
    } catch (error) {
      console.error("Error fetching shared filter:", error);
    }
    return {};
  };

  getShareFilterValue = () => {
    let filterval = this.checkFilterLocalAndConvert();
    let parsedLocal = {};
    if (filterval) {
      try {
        parsedLocal =
          typeof filterval === "object" ? filterval : JSON.parse(filterval);
      } catch (e) {
        parsedLocal = {};
      }
    }
    let newval = { ...parsedLocal, ...(this.state.filterMod || {}) };
    return newval;
  };

  // Generate SHarable Link

  generateShareLink = async () => {
    // If already generated, do nothing (Popover will show the link)

    if (this.state.isPopoverOpen) {
      this.setState({ isPopoverOpen: false });
      return;
    }

    let newval = this.getShareFilterValue();

    if (!newval || Object.keys(newval).length === 0) {
      this.setState({
        generatingLink: false,
        shareUrl: "",
        isPopoverOpen: false,
      });
      // this.props.NotificationMessage({"code": 404, "message": "No Filter Data Available"});
      return;
    }

    if (this.state.shareUrl) {
      this.setState({ isPopoverOpen: true });
      return;
    }

    this.setState({ generatingLink: true, shareUrl: "", isPopoverOpen: true });

    let payload = {
      app_token: this.state.boarddata.app_token,
      attribute_set_key: this.state.boarddata.attribute_set_key,
      user_uuid: this.state.boarddata.user_uuid,
      filter_name: this.state.boarddata.attribute_set_key + `Shareble Filter`,
      filter_value: newval,
      filter_columns:
        this.state.columnDefs.length > 0
          ? this.state.columnDefs.map((column) => ({
              field: column.field,
              show_on_column: column.show_on_column,
              sequence: column.sequence,
              width: column.width,
              attribute_key: column.field,
              attribute_set_key: column.attribute_set_key,
              app_token: column.app_token,
            }))
          : [],

      is_system: 0,
      filter_type: 3,
    };

    try {
      const apiEndpoint = `${process.env.REACT_APP_API}/create-custom-filter`;

      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.code !== 200) {
        throw new Error(data.message || "Failed to save filter");
      }

      const filter_id = data.data.filter_id;
      const url = `${window.location.origin}/tattle/${this.state.boarddata.attribute_set_key}/list/share/${filter_id}`;

      this.setState({ shareUrl: url });
    } catch (err) {
      this.setState({
        generatingLink: false,
        shareUrl: "",
        isPopoverOpen: false,
      });
      console.error("Save filter failed:", err);
    } finally {
      this.setState({ generatingLink: false });
    }
  };

  saveAppliedFilters = async () => {
    let newval = this.getShareFilterValue();

    if (!newval || Object.keys(newval).length === 0) {
      // this.props.NotificationMessage({"code": 404, "message": "No Filter Data Available"});
      return;
    }
    this.setState({ isFilterCreate: true });
  };

  // copy filter link handler
  copyFilterLinkHandler = () => {
    this.setState((state) => {
      return {
        ...state,
        linkCopied: true,
      };
    });
    let newval = this.getShareFilterValue();
    let filterval = JSON.stringify(newval);
    if (filterval) {
      const queryParams = {
        q: filterval,
      };

      const queryString = Object.keys(queryParams)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`,
        )
        .join("&");
      const url = `${window.location.origin}${window.location.pathname}?${queryString}`;
      navigator.clipboard.writeText(url);
    } else {
      const url = `${window.location.origin}${window.location.pathname}?q=`;
      navigator.clipboard.writeText(url);
    }
    setTimeout(() => {
      this.setState((state) => {
        return {
          ...state,
          linkCopied: false,
        };
      });
    }, 500);
  };

  showHideAttribute = () => {
    this.setState((state) => {
      return {
        ...state,
        showAllattribute: !state.showAllattribute,
      };
    });
  };

  getCreateTodoHandler = (columnsDefs, params) => {
    if (this.state.isLoading) {
      return <Loading />;
    }

    const fields = [];

    this.state.todoAttr?.forEach((item) => {
      let validation = {};
      if (item.is_required && item.attribute_type === "tel") {
        const phoneRegExp =
          /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
        validation = {
          required: string()
            .required(this.firstUpper(item.headerName + " is required "))
            .matches(phoneRegExp, "Phone number is not valid")
            .max(10, "10 number is allowed"),
        };
      } else if (item.is_required && item.attribute_type === "text") {
        validation = {
          required: string()
            .trim()
            .required(this.firstUpper(item.headerName + " is required ")),
        };
      } else if (item.is_required && item.attribute_type === "textarea") {
        validation = {
          required: string()
            .trim()
            .required(this.firstUpper(item.headerName + " is required ")),
        };
      } else if (item.is_required && item.attribute_type === "select") {
        validation = {
          required: item.is_multiple
            ? array()
                .min(1)
                .required(this.firstUpper(item.headerName + " is required "))
            : string().required(
                this.firstUpper(item.headerName + " is required "),
              ),
        };
      } else if (item.is_required && item.attribute_type === "priority") {
        validation = {
          required: item.is_multiple
            ? array()
                .min(1)
                .required(this.firstUpper(item.headerName + " is required "))
            : string().required(
                this.firstUpper(item.headerName + " is required "),
              ),
        };
      } else if (item.is_required && item.attribute_type === "checkbox") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required "),
          ),
        };
      } else if (item.attribute_type === "number") {
        if (item.is_required) {
          validation = {
            required: number()
              .required(this.firstUpper(item.headerName + " is required "))
              .min(0),
          };
        } else {
          validation = {
            required: number()
              .min(
                0,
                this.firstUpper(
                  item.headerName + " must be equal or greater than 0",
                ),
              )
              .nullable(true)
              .transform((_, val) => (val ? Number(val) : null)),
          };
        }
      } else if (item.is_required && item.attribute_type === "radio") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required "),
          ),
        };
      } else if (item.is_required && item.attribute_type === "api") {
        if (item.is_multiple) {
          validation = {
            required: array().required(
              this.firstUpper(item.headerName + " is required "),
            ),
          };
        } else {
          validation = {
            required: string().required(
              this.firstUpper(item.headerName + " is required "),
            ),
          };
        }
      } else if (item.is_required && item.attribute_type === "assign_to") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required "),
          ),
        };
      } else if (item.is_required && item.attribute_type === "customer") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required "),
          ),
        };
      } else if (item.is_required && item.attribute_type === "assign_to") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required "),
          ),
        };
      } else if (item.is_required && item.attribute_type === "category") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required "),
          ),
        };
      } else if (item.is_required && item.attribute_type === "status") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required "),
          ),
        };
      } else if (item.is_required && item.attribute_type === "board") {
        validation = {
          required: string().required(
            this.firstUpper(item.headerName + " is required "),
          ),
        };
      } else if (item.attribute_type === "tel") {
        const phoneRegExp =
          /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
        validation = {
          required: string()
            .matches(phoneRegExp, "Phone number is not valid")
            .max(10, "10 number is allowed"),
        };
      } else if (item.attribute_type === "email") {
        validation = {
          required: string().email("Invalid Email"),
        };
      }
      fields.push({
        name: item.field,
        initialValue: this.state.formdata[item.field] || "",
        type: item.attribute_type,
        ...validation,
      });
    });

    const initialValues = Object.fromEntries(
      fields.map((fiel) => [fiel.name, fiel.initialValue]),
    );
    const validObject = Object.fromEntries(
      fields.map((fiel) => [fiel.name, fiel.required]),
    );
    const userSchema = object().shape(validObject);
    this.clearFormSelect = new Array(this.state.todoAttr.length).fill(
      createRef(),
    );
    let hiddenAttribute = this.state.todoAttr.filter(
      (it) => it.hidden_form_field == true,
    );

    return (
      <>
        <Row>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={userSchema}
            onSubmit={(values, { resetForm }) => {
              this.formSubmitHandler(values);
            }}
          >
            {(formik) => {
              return (
                this.state.todoAttr.length > 0 && (
                  <NewForm>
                    <Row>
                      {this.state.todoAttr?.map((item, index) => {
                        if (!item.hidden_form_field) {
                          return this.getHiddenFormFieldValue(
                            formik,
                            item,
                            index,
                          );
                        }
                      })}
                      {hiddenAttribute.length > 0 && (
                        <div
                          className={`${
                            this.state.showAllattribute ? "showAllAttr" : ""
                          } hideAttr`}
                        >
                          {hiddenAttribute.map((item, index) => {
                            return this.getHiddenFormFieldValue(
                              formik,
                              item,
                              index,
                            );
                          })}
                        </div>
                      )}

                      {hiddenAttribute.length > 0 && (
                        <Link
                          className="show_more_attribute_detals"
                          onClick={(evt) => {
                            evt.preventDefault();
                            this.showHideAttribute();
                          }}
                          to={"#"}
                        >
                          {!this.state.showAllattribute
                            ? "More Details >>"
                            : "<< Show Less"}
                        </Link>
                      )}
                    </Row>

                    <Button
                      className="muBtn _blue mt-3"
                      text={this.state.isSubmitting ? "Saving..." : "Save"}
                      type="submit"
                      disabled={this.state.isSubmitting}
                    />
                  </NewForm>
                )
              );
            }}
          </Formik>
        </Row>
      </>
    );
  };
  reasonModalClose = () => {
    this.setState(
      (state) => {
        return {
          ...state,
          showReason: false,
          modalInProgress: false,
        };
      },
      () => {
        // return this.gridApi
        //   .getRowNode(this.state.editData.node.id)
        //   .setDataValue(
        //     this.state.editData.column.colId,
        //     this.state.editData.oldValue
        //   );
      },
    );
  };

  render() {
    const sideBar = {
      defaultToolPanel: "",
    };

    const { filter_id: fil_id } = this.props.match.params;

    let set_name = "";
    if (this.props.location.state?.data?.attribute_set_name) {
      set_name = this.props.location.state.data?.attribute_set_name;
    } else {
      set_name = this.props.location?.state?.data?.attribute_set_name;
    }

    const newval = this.getShareFilterValue();
    const isFilterAvailable = !(!newval || Object.keys(newval).length === 0);
    return (
      <>
        <Error>
          <ReasonModal
            show={this.state.showReason}
            close={this.reasonModalClose}
          >
            <div className="dynamicReasonAsking">
              <AttributeReturnObj
                attributes={this.state.modalData}
                editData={this.state.editData}
                attributeHandlerChanges={this.attributeHandlerChanges}
              />
            </div>

            {Object.values(this.state?.reasonError || {}).map((item) => (
              <div className="error">{item}</div>
            ))}
            <ReasonNote
              getRawData={this.submitReasonData}
              users={this.state.users}
              addnote={true}
              toolbar={true}
              isAdding={this.state.isAddReason}
              customer_tattle_uuid={Number(this.props.match.params.id)}
              //note_type={this.state.noteType}
              note_type={this.state.note_type}
              attribute_set_key={this.props.match.params.attribute_set_key}
              button={true}
              buttonText="Add Reason"
              buttonDisabled={this.state.buttonDisabled}
            />
          </ReasonModal>
        </Error>
        {this.state.showTodoNote && (
          <MainCanvas
            show={this.state.showTodoNote}
            onClose={this.canvasCloseHandler}
            title="Notes"
          >
            {this.getNoteTodoView()}
          </MainCanvas>
        )}
        {this.state.showReviewCanvas && (
          <MainCanvas
            show={this.state.showReviewCanvas}
            onClose={this.canvasCloseHandler}
            title="Edit To Do"
          >
            {this.state.columnDefs.length > 0 &&
              Object.keys(this.state.singleTodoParams).length > 0 &&
              this.getReviewTodoHandler(
                this.state.columnDefs,
                this.state.singleTodoParams,
              )}
          </MainCanvas>
        )}
        <MainCanvas
          show={this.state.showtodocanvas}
          onClose={this.canvasCloseHandler}
          title={`Add ${this.state.boarddata.attribute_set_name}`}
        >
          {this.getCreateTodoHandler()}
        </MainCanvas>
        <Modal
          show={this.state.isFilterRemove}
          className="confirm"
          close={this.closeRemoveModal}
        >
          <div className="deleteAlert">
            <p>Do you want to delete this filter?</p>
            <div className="actionDelete">
              <Button
                className="muBtn _blue"
                text="Yes"
                onClick={() => this.removeFilterConfirmHandler()}
              />{" "}
              &nbsp;
              <Button
                className="muBtn _grey"
                text="Cancel"
                onClick={this.closeRemoveModal}
              />
            </div>
          </div>
        </Modal>
        {this.state.isFilterCreate && (
          <Modal show={this.state.isFilterCreate} close={this.closeModal}>
            <Form onSubmit={this.createCustomFilterHandler}>
              <div className="row">
                <div className="form-group">
                  <label>
                    View Name <span className="required_filter">*</span>
                  </label>{" "}
                  <input
                    type={"text"}
                    className="form-control"
                    placeholder="Custom view name"
                    name="filter_name"
                    ref={this.customFilterName}
                    onChange={this.validateFilter}
                    autoComplete="off"
                  />
                </div>
                <span className="required_filter">
                  {this.state.modalFilterNameError}
                </span>
              </div>
              <div className="row">
                <div className="form-group">
                  <Button
                    text="Create View"
                    type="submit"
                    className="muBtn _blue mb-3 mt-3"
                  />
                </div>
              </div>
            </Form>
          </Modal>
        )}

        {this.state.enebleClickFilter && (
          <CustomFilter
            show={this.state.enebleClickFilter}
            onClose={this.closeCustomFilter}
            columns={this.state.columnDefs}
            title="Create View"
            isEdit={this.state.isEdit}
            values={this.state.editFilterValues || ""}
            filterSubmit={this.submitFilterHandler}
            isFilterCreate={this.isFilterCreate}
            filterText={this.state.filterText}
            createFilterByView={this.createFilterByView}
          />
        )}
        {this.state.enebleAdvancedClickFilter && (
          <AdvancedFilter
            show={this.state.enebleAdvancedClickFilter}
            onClose={this.closeAdvanceFilter}
            columns={this.state.columnDefs}
            title="Advanced Filter"
            isEdit={this.state.isEdit}
            values={this.state.editFilterValues || ""}
            advfilterSubmit={this.submitAdvFilterHandler}
            isAdvFilterCreate={this.isAdvFilterCreate}
            advfilterToShow={this.state.advfilterToShow}
            createFilterByView={this.createFilterByView}
          />
        )}
        {this.state.createBoard.board && (
          <Error>
            <Message board={this.state.createBoard} position="bottom-end" />
          </Error>
        )}
        <div className="mainContent-panel-wrap" style={{ overflow: "auto" }}>
          {this.state.showAttrModal ? (
            <Error>
              <AttributeModal
                onSubmitAttrCreate={this.onSubmitAttrCreate}
                show={this.state.showAttrModal}
                cancel={this.canceModal}
                showCanvas={this.showCanvasForm}
                text="Apply"
                broadpopup={this.showboardpopup}
                updateAttrType={this.updateAttrType}
              />
            </Error>
          ) : (
            ""
          )}

          <Header
            brecum_name={{ name: "", link: "" }}
            brecum_page={this.state.boarddata.attribute_set_name}
            pageName="listing"
          />

          {this.state.showCanvas && (
            <Error>
              <FormCanvas
                placement="end"
                values={this.state.formvalues}
                onSubmit={this.submitAttrForm}
              />
            </Error>
          )}
          <div className="main_custom_class">
            <Error>
              <NewCustomFilter
                filters={this.state.boarddata.filter}
                getFilteredObj={this.getFilteredObj}
                enebleClickFilter={this.enebleClickFilter}
                enebleAdvancedClickFilter={this.enebleAdvancedClickFilter}
                attribute_set_type={this.state.boarddata.attribute_set_type}
                isAdmin={this.state.boarddata.is_admin == 1 ? 1 : 0}
                removeFilterHandler={this.removeFilterHandler}
                className="listingpagefilter"
              />
            </Error>

            <Container fluid className="g-0 fullHeight">
              <div
                className="page-content pt-1 new-content-main"
                style={!this.props.toggleMenu ? { marginLeft: "180px" } : {}}
              >
                {/* <p className="col-form-label txt-dark d-flex pb-0">
                <Back
                  name="Back"
                  to="/board/list"
                  className="txt-dark underline-none float-end"
                />{" "}
              </p> */}

                <Card className="border-0 main_child_class">
                  <Card.Body className="parentcrdclass">
                    {this.state.renameAttr.rename ? (
                      <Error>
                        <RenameAttrModal
                          rename={this.state.renameAttr}
                          showCanvas={this.showCanvasForm}
                          createNewOptions={this.createNewOption}
                        />
                      </Error>
                    ) : (
                      ""
                    )}

                    <Row className="justify-content-end align-items-center gx-2">
                      <Col>
                        <div className="board-parent__division">
                          <Back
                            className="txt-dark underline-none"
                            {...(this.props.match?.params
                              ?.second_attribute_set_key
                              ? {
                                  onClick: () => {
                                    const filterdata =
                                      this.state.boarddata?.filter
                                        ?.system_filter?.[0] || null;

                                    console.log("target4566", filterdata);

                                    // Navigate
                                    this.props.history.push(
                                      `/tattle/${this.props.match.params.attribute_set_key}/list`,
                                      { filterdata },
                                    );

                                    // Then call your function
                                    this.getFilteredObj(filterdata);
                                  },
                                }
                              : {
                                  to: "/board/list",
                                })}
                            name=""
                          />
                          <div
                            className="dropdown untitled-drop col-10"
                            onClick={
                              +this.state.boarddata.is_admin === 1
                                ? this.enableinlineEditing
                                : null
                            }
                            ref={this.mainboardchange}
                          >
                            {!this.state.editiBoard && (
                              <span className="inline-edit-board">
                                {/*this.state.attribute_set_name ||
                                  this.state.boarddata.attribute_set_name || this.state.filterName}{" "*/}
                                <OverlayTrigger
                                  key={"filter-list"}
                                  placement={"top"}
                                  overlay={
                                    <Tooltip id={`filter-name`}>
                                      <strong>
                                        {" "}
                                        {this.state.filterName
                                          ? this.state.filterName
                                          : this.state.attribute_set_name ||
                                            this.state.boarddata
                                              .attribute_set_name}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    {this.props.match.params
                                      .second_attribute_set_key
                                      ? this.props.match.params.second_attribute_set_key
                                          .charAt(0)
                                          .toUpperCase() +
                                        this.props.match.params.second_attribute_set_key.slice(
                                          1,
                                        )
                                      : (
                                          (this.state.filterName
                                            ? typeof this.state.filterName === "string" && this.state.filterName.length > 20
                                              ? this.state.filterName.slice(
                                                  0,
                                                  20,
                                                ) + "..."
                                              : this.state.filterName
                                            : this.state.attribute_set_name ||
                                              this.state.boarddata
                                                .attribute_set_name) || ""
                                        ).replace(/^./, (str) =>
                                          str.toUpperCase(),
                                        )}
                                  </span>
                                </OverlayTrigger>
                                {this.state.numRecordTodo != null &&
                                  `(${+this.state.numRecordTodo})`}
                                {+this.state.boarddata.is_admin == 1 && (
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11.4898 4.10156H2.51011C2.24077 4.10156 2.09038 4.38594 2.25718 4.58008L6.74702 9.78633C6.87554 9.93535 7.123 9.93535 7.25288 9.78633L11.7427 4.58008C11.9095 4.38594 11.7591 4.10156 11.4898 4.10156Z"
                                      fill="#67717A"
                                      fillOpacity="0.4"
                                    ></path>
                                  </svg>
                                )}
                              </span>
                            )}

                            {this.state.editiBoard && (
                              <form onSubmit={this.inlineBoardNameChange}>
                                <input
                                  ref={this.boardeditFocus}
                                  className="form-control col-7"
                                  defaultValue={
                                    this.state.attribute_set_name ||
                                    this.state.boarddata.attribute_set_name
                                  }
                                  onChange={(e) =>
                                    this.inlineBoardNameChangeHandler(e)
                                  }
                                  onBlur={this.submitRenameBoard}
                                />
                              </form>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-auto">
                        <div className="customviewc">
                          <Whisper
                            open={isFilterAvailable && this.state.isPopoverOpen}
                            onClose={this.handlePopoverClose}
                            trigger={isFilterAvailable ? "click" : "none"}
                            placement="bottomEnd"
                            speaker={
                              <Popover style={{ padding: "6px" }}>
                                {this.state.shareUrl ? (
                                  <div
                                    ref={this.shareWhisperRef}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      border: "1px solid #e5e5e5",
                                      borderRadius: "6px",
                                      background: "#fff",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      readOnly
                                      value={this.state.shareUrl}
                                      style={{
                                        border: "none",
                                        padding: "8px 12px",
                                        width: "220px",
                                        outline: "none",
                                        color: "#333",
                                        fontSize: "14px",
                                        background: "transparent",
                                      }}
                                      onClick={(e) => e.target.select()}
                                    />
                                    <button
                                      type="button"
                                      style={{
                                        border: "none",
                                        borderLeft: "1px solid #e5e5e5",
                                        background: "#fff",
                                        padding: "8px 12px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        outline: "none",
                                      }}
                                      onClick={() => {
                                        navigator.clipboard.writeText(
                                          this.state.shareUrl,
                                        );
                                        this.setState({ linkCopied: true });
                                        setTimeout(() => {
                                          this.setState({ linkCopied: false });
                                        }, 1500);
                                      }}
                                    >
                                      {this.state.linkCopied ? (
                                        <i
                                          className="fa fa-check"
                                          style={{
                                            color: "#28a745",
                                            fontSize: "14px",
                                          }}
                                        ></i>
                                      ) : (
                                        <i
                                          className="fa fa-copy"
                                          style={{
                                            color: "#555",
                                            fontSize: "14px",
                                          }}
                                        ></i>
                                      )}
                                    </button>
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      padding: "8px",
                                      fontSize: "14px",
                                      color: "#666",
                                    }}
                                  >
                                    {this.state.generatingLink
                                      ? "Generating link..."
                                      : "Click share to generate link"}
                                  </div>
                                )}
                              </Popover>
                            }
                          >
                            <Button
                              className="muBtn"
                              onClick={isFilterAvailable ? this.generateShareLink : undefined}
                              isDisabled={!isFilterAvailable}
                              disabled={!isFilterAvailable}
                              color={!isFilterAvailable ? "#b0b7be" : "#7b8794"}
                              fSize={16}
                              padding={"9px 10px"}
                              border={
                                !isFilterAvailable
                                  ? "1px solid #e5e5e5"
                                  : this.state.shareUrl && fil_id
                                  ? "1px solid #006efa"
                                  : "1px solid #dbe1ea"
                              }
                              style={{
                                cursor: !isFilterAvailable ? "not-allowed" : "pointer",
                                opacity: !isFilterAvailable ? 0.6 : 1,
                                backgroundColor: !isFilterAvailable ? "#f5f5f5" : "transparent",
                              }}
                            >
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="kanban-group-check">
                                    <strong>Share current view</strong>
                                  </Tooltip>
                                }
                              >
                                <i className="fa fa-share-alt"></i>
                              </OverlayTrigger>
                            </Button>
                          </Whisper>

                          {/* <span
                            className={`copy_link ${
                              this.state.linkCopied ? "enablecopilinked" : ""
                            }`}
                            style={{ zIndex: 99999 }}
                          >
                            Copied
                          </span> */}
                        </div>
                      </Col>
                      <Col className="col-auto">
                        <div className="customviewc">
                          <Button
                            className="muBtn"
                            onClick={isFilterAvailable ? this.saveAppliedFilters : undefined}
                            isDisabled={!isFilterAvailable}
                            disabled={!isFilterAvailable}
                            color={!isFilterAvailable ? "#b0b7be" : "#7b8794"}
                            fSize={16}
                            padding={"9px 10px"}
                            border={
                              !isFilterAvailable
                                ? "1px solid #e5e5e5"
                                : "1px solid #dbe1ea"
                            }
                            style={{
                              cursor: !isFilterAvailable ? "not-allowed" : "pointer",
                              opacity: !isFilterAvailable ? 0.6 : 1,
                              backgroundColor: !isFilterAvailable ? "#f5f5f5" : "transparent",
                            }}
                          >
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="kanban-group-check">
                                  <strong>Save current view</strong>
                                </Tooltip>
                              }
                            >
                              <i className="fa fa-save"></i>
                            </OverlayTrigger>
                          </Button>
                        </div>
                      </Col>
                      {/* {+this.state.boarddata.is_admin === 1 && ( */}
                      <Col className="col-auto">
                        <div className="row-hide-sele">
                          <div>
                            {/* {this.state.hidden_column_counts > 0 && ( */}
                              <HideDropDown
                                columnsHide={this.state.hidden_columns}
                                columnsShow={this.state.columnDefs}
                                showAttr={this.showClumnByCheckbox}
                                inputChangeCheckbox={this.inputChangeCheckbox}
                              />
                            {/* )} */}
                          </div>
                        </div>
                      </Col>

                      {this.state.boarddata.attribute_set_type != 4 && (
                        <Col>
                          <div className="search-filter">
                            <Search
                              ref={this.searchRef}
                              placeholder="Search By Title or ID or Description"
                              type="text"
                              onChange={this.searchGrid}
                              hide={false}
                              val={this.state.globalSearch}
                              onClick={this.customFilterHandler}
                              enableCustomFilter={this.state.enableCustomFilter}
                              onClose={this.closeCustomFilterDropdown}
                              options={this.state.customFilter}
                              enebleClickFilter={this.enebleClickFilter}
                              getFilteredObj={this.getFilteredObj}
                              selectedFilter={this.state.selectedFilter}
                              deleteCustomFilter={this.deleteCustomFilter}
                            />
                          </div>
                        </Col>
                      )}
                      <Col
                        className="col-auto"
                        onClick={() => this.resetAllFilter()}
                      >
                        <OverlayTrigger
                          key={"reset"}
                          placement={"top"}
                          overlay={
                            <Tooltip id={`tooltip-reset`}>
                              <strong>Reset Filter</strong>
                            </Tooltip>
                          }
                        >
                          <TimeSvg />
                        </OverlayTrigger>
                      </Col>
                      <Col className="col-auto">{this.getAddToButton()}</Col>
                      {/* this.state.boarddata?.attribute_set_type !== 1 &&
                        this.state.boarddata?.attribute_set_type !== 10 && ( */}
                      <Col className="col-auto">{this.getKanbanViewUi()}</Col>
                      {/* )} */}
                      {/* {this.state.boarddata.is_admin == 1 && (
                        <div className="col-auto">
                          <OverlayTrigger
                            key={"export"}
                            placement={"top"}
                            overlay={
                              <Tooltip id={`tooltip-export`}>
                                <strong>Export to csv</strong>
                              </Tooltip>
                            }
                          >
                            <div
                              className="muBtn _primary  border"
                              onClick={this.exportToCsv}
                            >
                              <span className="svg">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                                    stroke="#5C5F62"
                                    strokeWidth="1.33"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                  <path
                                    d="M4.6665 6.66669L7.99984 10L11.3332 6.66669"
                                    stroke="#5C5F62"
                                    strokeWidth="1.33"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                  <path
                                    d="M8 10V2"
                                    stroke="#5C5F62"
                                    strokeWidth="1.33"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                          </OverlayTrigger>
                        </div>
                      )} */}
                    </Row>

                    {((this.state.columnsHide?.length || 0) > 0 ||
                      (this.state.selectedrowsdata?.length || 0) > 0) && (
                      <Error>
                        <StatusBar
                          noHide={this.state.columnsHide || []}
                          hidecolumn={this.hideSelectedRow}
                          showAttributeListDropDown={
                            this.showAttributeListDropDown
                          }
                          columnLists={[...(this.state.columnDefs || []), ...(this.state.hidden_columns || [])]}
                          userType={this.state.boarddata.is_admin}
                          isBulkUpload={this.state.isBulkUpload}
                          showattrdrop={this.state.showattrdrop}
                          hideattrdrop={this.hideattrdrop}
                          code={this.props.attributes?.code}
                          type="item"
                          clearBulkAction={this.clearBulkAction}
                          users={this.state.users}
                          selectedrowsdata={this.state.selectedrowsdata || []}
                          submitBulkUpdate={this.submitBulkUpdate}
                          bulkProgressActive={this.state.bulkProgressActive}
                          bulkProgressPercent={this.state.bulkProgressPercent}
                        />
                      </Error>
                    )}
                    {this.state.bulkProgressActive && (this.state.selectedrowsdata?.length || 0) === 0 && (
                      <StatusBar
                        noHide={[]}
                        hidecolumn={() => {}}
                        showAttributeListDropDown={() => {}}
                        isBulkUpload={false}
                        showattrdrop={false}
                        hideattrdrop={() => {}}
                        type="item"
                        clearBulkAction={() => {}}
                        users={{}}
                        selectedrowsdata={[]}
                        submitBulkUpdate={() => {}}
                        bulkProgressActive={this.state.bulkProgressActive}
                        bulkProgressPercent={this.state.bulkProgressPercent}
                      />
                    )}
                    <div className="mt-3 parentAgGrid">
                      <span className="loadingx"></span>
                      <div className="ag-grid-main-header">
                        <div
                          className={`ag-theme-alpine ${this.props.match.params.attribute_set_key}`}
                        >
                          <Error>
                            <AgGridComponent
                              onFirstDataRendered={this.onFirstDataRendered}
                              rowSelection={this.state.rowSelection}
                              attribute_set_type={
                                this.state.boarddata.attribute_set_type
                              }
                              users={this.state.users}
                              bulkUpdateDone={this.state.bulkUpdateDone}
                              isReset={this.state.isReset}
                              enableRangeSelection={true}
                              columnResize={true}
                              is_admin={this.state.boarddata.is_admin}
                              onColumnMoved={this.onrowdragmove}
                              columnDefs={this.state.columnDefs}
                              onCellValueChanged={this.onRowValueChanged}
                              defaultColDef={this.state.defaultColDef}
                              onGridReady={(evt) => {
                                this.getgridapi.current = evt;
                                this.onGridReady(evt);
                              }}
                              getRowClass={this.getRowClass}
                              columnChangeFlag={this.state.columnChangeFlag}
                              callStatusPanel={this.perPageSizeChange}
                              gridApi={this.getgridapi.current}
                              cacheBlockSize={this.state.perPageSizeChange}
                              maxBlocksInCache={this.state.perPageSizeChange}
                              child={false}
                              onColumnResized={this.onColumnResized}
                              conditions={this.state.conditions}
                              globalSearch={this.state.globalSearch}
                              filterMod={this.state.filterMod}
                              perPageSizeChange={+this.state.perPageSizeChange}
                              checkIsCompleteHandler={
                                this.checkIsCompleteHandler
                              }
                              getTodoViewCanvas={this.getTodoViewCanvas}
                              getFilterParams={this.getFilterParams}
                              resetFilter={this.state.resetFilter}
                              groupByKeyCreater={this.groupByKeyCreater}
                              onRowSelected={this.onRowSelected}
                              selectAllRowHandler={this.selectAllRowHandler}
                              onSortRequested={this.onSortRequested}
                              onCheckBoxChange={this.onCheckBoxChange}
                              renameAttribute={this.renameAttribute}
                              params={this.props}
                              openNoteHandler={this.openNoteHandler}
                              filterName={this.state.filterName}
                            />
                          </Error>
                        </div>
                        <div>
                          {this.state.boarddata?.is_admin == 1 && (
                            <div onClick={this.dynamicColumnHandler}>
                              <AddAttrSvg />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Container>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    attributes: state.attributes,
    login: state.loginDetails?.loginData,
    allBoard: state.allBoards,
    boardData: state.boardAttribute.filter,
    filterpopup: state.boardAttribute.filterpopup,
    todoData: state.boardAttribute,
    users: state.boardAttribute.users,
    toggleMenu: state.boardAttribute.toggleMenu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    callUserApi: (input) => {
      dispatch(action.userApiCall(input));
    },
    createAttribute: (input) => {
      dispatch(action.createattribute(input));
    },
    fetchAllColumns: (inputs) => {
      return dispatch(action.fetchAllcolumns(inputs));
    },
    fetchAllRows: (inputs, data = null) => {
      dispatch(action.fetchAllRows(inputs, data));
    },
    renameSingleBoard: (inputs) => {
      dispatch(action.renamesingleboard(inputs));
    },
    orderingColumns: (inputs) => {
      dispatch(action.columnOrdering(inputs));
    },
    renamingAttr: (inputs) => {
      return dispatch(action.renameAttribute(inputs));
    },
    checkSidebarLink: (set_key) => {
      dispatch(action.checkLinkForSideMenu(set_key));
    },
    hideColumn: (inputs) => {
      dispatch(action.hideColumn(inputs));
    },
    showColumns: (inputs) => {
      dispatch(action.showColumns(inputs));
    },
    columnResize: (inputs) => {
      dispatch(action.columnResize(inputs));
    },
    dispatchBulkUpdate: (inputs) => {
      dispatch(action.bulkUpdate(inputs));
    },
    getBoardDetailsActions: (input) => {
      return dispatch(action?.getBoardDetailsAction(input));
    },
    createCustomFilter: (input) => {
      return dispatch(action.createCustomFilter(input));
    },
    removeFilter: (input) => {
      dispatch(action.removeFilter(input));
    },
    editFilter: (input) => {
      dispatch(action.editFilter(input));
    },
    todoHandler: (input) => {
      dispatch(action.TodoHandler(input));
    },
    isFilterReset: (input) => {
      dispatch(action.isFilterReset(input));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Details);
